import {Component, HostListener, OnInit, OnDestroy} from '@angular/core';
import {Location} from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';
import {ConstantsService, ModulosEnum} from '../../fidelidade/ConstantsService';
import {PedidosService} from '../../services/pedidos.service';
import {ProdutoService} from '../../services/produto.service';
import {ContatosService} from '../../services/contatos.service';
import {EnderecoService} from '../../services/endereco.service';
import {FormasDePagamentoService} from '../../services/formas-de-pagamento.service';
import {AutorizacaoService} from '../../services/autorizacao.service';
import {ComandaService} from '../../services/comanda.service';
import {CartaoClienteService} from '../../services/cartao-cliente.service';
import {UsuarioService} from '../../services/usuario.service';
import {GrupolojasService} from '../../superadmin/services/grupolojas.service';
import {DialogRef, DialogService} from '@progress/kendo-angular-dialog';
import {NotificationRef, NotificationService} from '@progress/kendo-angular-notification';
import {EnumOrigemPedido} from '../../../../server/lib/emun/EnumOrigemPedido';
import {Subscription} from 'rxjs';
import {CadEnderecoContatoComponent} from '../../fidelidade/cad-endereco-contato/cad-endereco-contato.component';
import {KendoPopupUtils} from '../../lib/KendoPopupUtils';
import {NovoContatoComponent} from '../../novo-contato/novo-contato.component';

type PayMethodSectionKey = 'online' | 'offline';

interface PayMethodVM {
  id: string;
  name: string;
  desc: string | null;
  color: string;
  icon: string;
  sectionKey: PayMethodSectionKey;
  original: any;
}

interface PayMethodSectionVM {
  key: PayMethodSectionKey;
  title: string;
  badge: string;
  badgeColor: string;
  methods: PayMethodVM[];
}

interface CashbackStateV3 {
  id?: any;
  cartao: any;
  formaDePagamento?: any;
  valor: number;
}

interface ResgateStateV3 {
  cartao: any;
  formaDePagamento?: any;
  usar?: boolean;
  saldoInsuficente?: boolean;
}

interface NovoPedidoV3RouteContext {
  urlRetorno: string | null;
  nome: string | null;
  tel: string | null;
  centralPedidos: boolean;
  centralEmpresaOrigemId: string | null;
  centralContatoId: string | null;
  centralEnderecoId: string | null;
  bal: boolean;
  idMesa: string | null;
  idComanda: string | null;
  idCartaoConsumo: string | null;
  idGarcom: string | null;
  modoGarcom: boolean;
  novaComanda: boolean;
  codigoPedido: string | null;
  copiar: boolean;
}

@Component({
  selector: 'app-tela-novo-pedido-v3',
  templateUrl: './tela-novo-pedido-v3.component.html',
  styleUrls: ['./tela-novo-pedido-v3.component.scss']
})
export class TelaNovoPedidoV3Component implements OnInit, OnDestroy {
  private readonly defaultOrderType = 'delivery';
  private initialDeliverySubType: 'retirada' | 'entrega' = 'entrega';
  private routeContext: NovoPedidoV3RouteContext = {
    urlRetorno: null,
    nome: null,
    tel: null,
    centralPedidos: false,
    centralEmpresaOrigemId: null,
    centralContatoId: null,
    centralEnderecoId: null,
    bal: false,
    idMesa: null,
    idComanda: null,
    idCartaoConsumo: null,
    idGarcom: null,
    modoGarcom: false,
    novaComanda: false,
    codigoPedido: null,
    copiar: false
  };
  private failedImageIds = new Set<number>();
  private routeBootstrapStarted = false;
  private routeLookupContactDone = false;
  private routeLookupMesaDone = false;
  private routeLookupComandaDone = false;
  private routeLookupCartaoDone = false;
  private routeLookupGarcomDone = false;
  private routeMesaNoIdApplied = false;
  private comandaSelecionada: any = null;
  private mesaSelecionada: any = null;
  private garcomSelecionado: any = null;
  private cartaoClienteSelecionado: any = null;

  // === CENTRAL DE PEDIDOS ===
  centralPedidosCarregando = false;
  centralPedidosErro = '';
  centralPedidosContexto: any = null;
  centralPedidosBusca = '';
  centralPedidosDialogAberto = false;
  centralPedidosModoTrocaCliente = false;
  centralPedidosBuscando = false;
  centralPedidosCriandoCliente = false;
  centralPedidosClientes: any[] = [];
  centralPedidosClientesAgrupados: any[] = [];
  centralPedidosClienteSelecionado: any = null;
  centralPedidosEnderecos: any[] = [];
  centralPedidosEnderecoSelecionado: any = null;
  centralPedidosLojasDialogAberto = false;
  centralPedidosLojaDestino: any = null;
  centralPedidosLojaManual = false;
  centralPedidosRoteamento: any = null;
  centralPedidosEntrega: any = null;
  centralPedidosPreparando = false;
  centralAtendimentoPreparado = false;

  // === TIPO DE COR POR MODULO ===
  typeColors: any = {
    balcao:   {primary: '#6366f1', gradient: 'linear-gradient(135deg,#6366f1,#818cf8)', tint: '#eef2ff', label: 'Pedido Balcao', icon: 'store'},
    retirada: {primary: '#6366f1', gradient: 'linear-gradient(135deg,#6366f1,#818cf8)', tint: '#eef2ff', label: 'Pedido Retirada', icon: 'store'},
    delivery: {primary: '#ea580c', gradient: 'linear-gradient(135deg,#ea580c,#f97316)', tint: '#fff7ed', label: 'Pedido Delivery', icon: 'truck'},
    mesa:     {primary: '#0891b2', gradient: 'linear-gradient(135deg,#0891b2,#06b6d4)', tint: '#ecfeff', label: 'Pedido Mesa', icon: 'layout'}
  };

  // === ESTADO GLOBAL ===
  orderType: string = null;
  isMobile = false;
  mCartOpen = false;
  mCustomizeOpen = false;
  subType: 'retirada' | 'entrega' = 'retirada';

  // === CATEGORIAS E PRODUTOS ===
  categorias: any[] = [];
  produtos: any[] = [];
  productsLoading = false;
  activeCat = 'Todos';
  search = '';
  showProductPhotos = true;
  _cachedCategoryList: any[] = [];
  readonly productLoadingSkeletons = Array.from({length: 12}, (_, i) => i);
  readonly categoryLoadingSkeletons = Array.from({length: 8}, (_, i) => i);

  // === CARRINHO ===
  cart: any[] = [];

  // === CLIENTE ===
  showClientModal = false;
  clientModalAddressOnly = false;
  clientSearch = '';
  clientResults: any[] = [];
  clientSearchLoading = false;
  clientSearchError = false;
  selectedContact: any = null;
  selectedAddress: any = null;
  customerName = '';
  identificacaoBalcao = '';
  customerPhone = '';
  deliveryFee: any = '';
  deliveryFeeLoading = false;
  deliveryFeeError = '';
  tableNum = '';
  expandedClientId: number = null;

  // === PERSONALIZAÇÃO ===
  selProduct: any = null;
  editingItem: any = null;
  qty = 1;
  selExtras: any = {};
  selSingleChoices: any = {};
  selCalda: any = null;
  colher: string = null;
  obs = '';
  discount = '';
  sbVis = false;
  errors: any = {};
  fieldErrors: any = {};
  fieldShakeKey: any = {};

  // === PAGAMENTO ===
  payScreen = false;
  orderDone = false;
  orderDoneNumber = '';
  printCupom = false;
  printVenda = false;
  payMethods: any[] = [];
  payDiscount = '';
  payDiscountType: 'R$' | '%' = 'R$';
  payCupom = '';
  payTroco = '';
  payObs = '';
  showPayGrid = true;
  availablePayMethods: PayMethodVM[] = [];
  payMethodSectionsView: PayMethodSectionVM[] = [];
  payAddressRequirementTouched = false;
  cashbackState: CashbackStateV3 = null;
  resgateState: ResgateStateV3 = null;
  usarSaldoCashback = false;
  payLater = false;
  marcarPedidoComoPago = false;

  // === AGENDAMENTO ===
  agendarEntrega = false;
  dataAgendamento: Date | null = null;
  horaAgendamento: Date | null = null;
  agoraAgendamento: Date = new Date();
  payAgendamentoRequirementTouched = false;

  // === EMPRESA ===
  empresa: any = null;
  customerAddress = '';
  private subs: Subscription[] = [];
  private clientSearchTimer: any = null;
  private clientSearchReqSeq = 0;
  private clientSearchLastTerm = '';
  private centralPedidosBuscaTimer: any = null;
  private centralPedidosBuscaReqSeq = 0;
  private centralPedidosBuscaUltimoTermo = '';
  private centralPedidosDialogFechamentoBloqueadoAte = 0;
  private deliveryFeeCalcTimer: any = null;
  private deliveryFeeReqSeq = 0;
  private deliveryFeeLastCalcKey = '';
  private mesaRedirectTimer: any = null;
  private uiNotificationRef: NotificationRef = null;
  private legacyCashbackPayMethod: any = null;
  private legacyResgatePayMethod: any = null;
  salvando = false;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private constantsService: ConstantsService,
    private pedidosService: PedidosService,
    private produtoService: ProdutoService,
    private contatosService: ContatosService,
    private enderecoService: EnderecoService,
    private formasPagamentoService: FormasDePagamentoService,
    private autorizacaoService: AutorizacaoService,
    private comandaService: ComandaService,
    private cartaoClienteService: CartaoClienteService,
    private usuarioService: UsuarioService,
    private grupolojasService: GrupolojasService,
    private dialogService: DialogService,
    private notificationService: NotificationService,
    private location: Location
  ) {
    this.checkMobile();
  }

  ngOnInit() {
    this.showProductPhotos = this.constantsService.pdvMostrarFotos;
    this.resolveRouteOrderTypeParam();
    this.applyRouteInitialContactPrefill();
    this.subs.push(
      this.constantsService.empresa$.subscribe((empresa) => {
        if (empresa && empresa.id) {
          this.empresa = empresa;
          if (this.centralPedidosAtivo && !this.centralAtendimentoPreparado) {
            return;
          }
          this.loadPaymentMethods();
          this.bootstrapRouteContextData();
          this.syncAgendamentoObrigatorio();
        }
      })
    );
    this.autorizacaoService.estaLogado().then((resp: any) => {
      if (!resp.logado) {
        const destino = this.centralPedidosAtivo
          ? '/admin-grupo/login?t=%2Fadmin-grupo%2Fcentral-pedidos'
          : '/admin/login';
        this.router.navigateByUrl(destino);
      }
    });
    this.selectModule(this.resolveInitialOrderType());
    this.applyInitialDeliverySubType();
    if (this.centralPedidosAtivo) {
      this.carregueCentralPedidos();
      return;
    }

    this.bootstrapRouteContextData();
  }

  ngOnDestroy() {
    this.clearClientSearchTimer();
    this.clearCentralPedidosBuscaTimer();
    this.clearDeliveryFeeCalcTimer();
    this.clearMesaRedirectTimer();
    if (this.uiNotificationRef) {
      this.uiNotificationRef.hide();
      this.uiNotificationRef = null;
    }
    this.deliveryFeeReqSeq++;
    this.centralPedidosBuscaReqSeq++;
    this.subs.forEach(s => s.unsubscribe());
  }

  @HostListener('window:resize')
  checkMobile() {
    this.isMobile = window.innerWidth < 768;
  }

  // ==========================================
  // ESTADO PDV
  // ==========================================
  get tc() {
    return this.typeColors[this.visualOrderTypeKey] || this.typeColors.retirada;
  }

  get visualOrderTypeKey(): 'balcao' | 'retirada' | 'delivery' | 'mesa' {
    if (this.orderType === 'balcao') {
      return 'balcao';
    }
    if (this.orderType === 'delivery' && this.subType === 'retirada') {
      return 'retirada';
    }
    if (this.orderType === 'mesa') return 'mesa';
    if (this.orderType === 'delivery') return 'delivery';
    return 'retirada';
  }

  get isBalcaoMode(): boolean {
    return this.orderType === 'balcao';
  }

  get mesaNumeroDestaque(): string {
    const numero = this.tableNum || this.mesaSelecionada?.numero || this.mesaSelecionada?.nome || '';
    if (numero) return String(numero);
    if (this.routeContext?.idMesa) return `#${this.routeContext.idMesa}`;
    return '--';
  }

  get mesaComandaDestaque(): string | null {
    const valor = this.comandaSelecionada?.codigo || this.comandaSelecionada?.numero || this.comandaSelecionada?.id || this.routeContext?.idComanda;
    return valor ? String(valor) : null;
  }

  get mesaGarcomDestaque(): string | null {
    const nome = this.garcomSelecionado?.nome;
    return nome ? String(nome) : null;
  }

  get isMesaSending(): boolean {
    return this.salvando && this.orderType === 'mesa';
  }

  get centralPedidosAtivo(): boolean {
    return !!this.routeContext?.centralPedidos;
  }

  get finalizeOrderButtonLabel(): string {
    return this.isMesaSending ? 'Enviando...' : 'Finalizar Pedido';
  }

  selectModule(type: string) {
    const normalizedType = type === 'mesa' ? 'mesa' : (type === 'balcao' ? 'balcao' : 'delivery');
    this.orderType = normalizedType;
    this.subType = normalizedType === 'mesa'
      ? 'retirada'
      : (normalizedType === 'balcao' ? 'retirada' : (type === 'delivery' ? 'entrega' : 'retirada'));
    this.marcarPedidoComoPago = normalizedType === 'balcao';

    if (normalizedType === 'mesa' && !this.tableNum && this.mesaSelecionada) {
      const numeroMesa = this.mesaSelecionada.numero ?? this.mesaSelecionada.nome;
      if (numeroMesa !== null && numeroMesa !== undefined) {
        this.tableNum = String(numeroMesa);
      }
    }
    this.payAddressRequirementTouched = false;
    if (this.centralPedidosAtivo && !this.centralAtendimentoPreparado) {
      this.categorias = [];
      this.produtos = [];
      this._cachedCategoryList = [{nome: 'Todos', count: 0, cor: '#6366f1', fundo: '#eef2ff'}];
      this.availablePayMethods = [];
      this.payMethods = [];
      this.refreshPayMethodSections();
      return;
    }
    this.loadProducts();
    this.loadPaymentMethods();
  }

  startNewOrder() {
    const nextType = this.orderType || this.defaultOrderType;
    this.resetAll();
    this.selectModule(nextType);
    this.applyInitialDeliverySubType();
  }

  goBack() {
    if (this.centralPedidosAtivo && this.centralAtendimentoPreparado) {
      this.reinicieCentralPedidos();
      return;
    }

    const urlRetorno = this.activatedRoute?.snapshot?.queryParams?.urlRetorno;
    if (urlRetorno) {
      this.router.navigateByUrl(urlRetorno).then(() => {});
      return;
    }

    if (window.history.length > 1) {
      this.location.back();
      return;
    }

    this.router.navigateByUrl('/admin/pedidos').then(() => {});
  }

  private reinicieCentralPedidos() {
    this.resetAll();
    this.selectModule('delivery');
    this.subType = 'entrega';
    this.payScreen = false;
  }

  // ==========================================
  // CARREGAR DADOS
  // ==========================================
  loadProducts() {
    if (this.centralPedidosAtivo && !this.centralAtendimentoPreparado) {
      this.categorias = [];
      this.produtos = [];
      this._cachedCategoryList = [{nome: 'Todos', count: 0, cor: '#6366f1', fundo: '#eef2ff'}];
      this.productsLoading = false;
      return;
    }

    const tipo = this.isDeliveryMode ? 'DELIVERY' : 'RETIRADA';
    this.productsLoading = true;
    this.produtoService.listeAhVenda(tipo).then((data: any) => {
      if (data) {
        this.categorias = data.categorias || [];
        const prods = data.produtos || [];
        this.produtos = prods.map((p: any) => {
          p._customizable = this.isCustomizable(p);
          p._popular = p.maisVendido || false;
          p._image = this.resolveProductImage(p);
          return p;
        });
        this.buildCategoryList();
      }
      this.productsLoading = false;
    }).catch(() => {
      this.categorias = [];
      this.produtos = [];
      this._cachedCategoryList = [{nome: 'Todos', count: 0, cor: '#6366f1', fundo: '#eef2ff'}];
      this.productsLoading = false;
    });
  }

  loadPaymentMethods() {
    if (this.centralPedidosAtivo && !this.centralAtendimentoPreparado) {
      this.availablePayMethods = [];
      this.payMethods = [];
      this.refreshPayMethodSections();
      return;
    }

    this.formasPagamentoService.listeFormasPagamentosLoja().then((formas: any) => {
      const sourceMethods = this.resolvePaymentMethodSourceList(formas);
      const legacyFiltered = this.applyLegacyPaymentMethodVisibility(sourceMethods);
      this.legacyCashbackPayMethod = legacyFiltered.cashbackMethod || null;
      this.legacyResgatePayMethod = legacyFiltered.resgateMethod || null;
      this.bindLoyaltyPaymentMethodsToStates();

      this.availablePayMethods = legacyFiltered.visible
        .filter((forma: any) => this.isPaymentMethodEnabledForSubType(forma))
        .map((forma: any) => this.mapToPayMethodVM(
          forma,
          this.isTunapayPixOnline(forma) ? 'online' : 'offline'
        ))
        .filter((m: PayMethodVM | null): m is PayMethodVM => !!m);
      this.payMethods = this.payMethods.filter((selected: any) =>
        this.availablePayMethods.some((available) => String(available.id) === String(selected.id))
      );
      this.syncPayMethodsWithCurrentTotal();
      if (this.payMethods.length === 0) {
        this.showPayGrid = true;
      }
      this.refreshPayMethodSections();
    }).catch(() => {
      this.legacyCashbackPayMethod = null;
      this.legacyResgatePayMethod = null;
      this.bindLoyaltyPaymentMethodsToStates();
      this.availablePayMethods = [];
      this.payMethods = [];
      this.showPayGrid = true;
      this.refreshPayMethodSections();
    });
  }

  private normalizePayMethodsResponse(formas: any): {online: any[]; offline: any[]} {
    if (!formas) return {online: [], offline: []};

    if (Array.isArray(formas)) {
      const online: any[] = [];
      const offline: any[] = [];
      formas.forEach((forma: any) => {
        if (this.isExplicitTrue(forma?.online)) {
          online.push(forma);
          return;
        }
        offline.push(forma);
      });
      return {online, offline};
    }

    const online = Array.isArray(formas.online) ? formas.online : [];
    const offline = Array.isArray(formas.offline) ? formas.offline : [];
    if (online.length || offline.length) return {online, offline};

    return {online: [], offline: []};
  }

  private resolvePaymentMethodSourceList(formasFromService: any): any[] {
    const empresaMethods = Array.isArray(this.empresa?.formasDePagamento) ? this.empresa.formasDePagamento : null;
    if (empresaMethods?.length) {
      return [...empresaMethods];
    }

    const grouped = this.normalizePayMethodsResponse(formasFromService);
    return [
      ...(grouped.online || []).map((forma: any) => ({...forma, online: forma?.online ?? true})),
      ...(grouped.offline || [])
    ];
  }

  private applyLegacyPaymentMethodVisibility(formas: any[]): {visible: any[]; cashbackMethod: any | null; resgateMethod: any | null} {
    const visible: any[] = [];
    let cashbackMethod: any = null;
    let resgateMethod: any = null;

    (formas || []).forEach((forma: any) => {
      if (!forma) return;

      if (this.isLegacyCashbackMethod(forma)) {
        cashbackMethod = forma;
      }

      const isResgate = this.isLegacyResgateMethod(forma);
      if (isResgate) {
        resgateMethod = forma;
      }

      if (this.isTunapayPixOnline(forma)) {
        if (this.pedidoBalcaoSemContato()) {
          return;
        }

        visible.unshift(forma);
        return;
      }

      if (this.isExplicitTrue(forma?.online) || isResgate || this.isLegacyCashbackMethod(forma)) {
        return;
      }

      visible.push(forma);
    });

    return {visible, cashbackMethod, resgateMethod};
  }

  private isTunapayPixOnline(forma: any): boolean {
    return this.isExplicitTrue(forma?.pix)
      && this.normalizeText(forma?.configMeioDePagamento?.meioDePagamento) === 'tunapay';
  }

  private pedidoBalcaoSemContato(): boolean {
    return this.isBalcaoMode && !this.selectedContact?.id;
  }

  private isLegacyResgateMethod(forma: any): boolean {
    if (!forma) return false;
    if (this.isLegacyCashbackMethod(forma)) return false;
    if (this.normalizeText(forma?.nome) === 'resgate') return true;
    return this.normalizeText(forma?.formaDePagamentoPdv?.tipo) === 'fidelidade';
  }

  private isLegacyCashbackMethod(forma: any): boolean {
    return this.normalizeText(forma?.nome) === 'cashback';
  }

  private bindLoyaltyPaymentMethodsToStates() {
    if (this.cashbackState) {
      this.cashbackState.formaDePagamento = this.legacyCashbackPayMethod || null;
      if (!this.cashbackState.formaDePagamento) {
        this.usarSaldoCashback = false;
        this.cashbackState.valor = 0;
      }
    }
    if (this.resgateState) {
      this.resgateState.formaDePagamento = this.legacyResgatePayMethod || null;
    }
  }

  private isPaymentMethodEnabledForSubType(forma: any): boolean {
    if (!forma) return false;
    const raw = this.subType === 'entrega' ? forma.habilitarEntrega : forma.habilitarRetirada;
    if (raw === undefined || raw === null || raw === '') return true;
    if (this.isExplicitFalse(raw)) return false;
    if (this.isExplicitTrue(raw)) return true;
    return !!raw;
  }

  private mapToPayMethodVM(forma: any, sectionKey: PayMethodSectionKey): PayMethodVM | null {
    const idRaw = forma?.id ?? forma?.codigo;
    const labels = this.normalizePayMethodLabels(forma);
    const isLegacyPixOnline = this.isTunapayPixOnline(forma);
    const name = isLegacyPixOnline ? 'PIX' : labels.name;
    if (!name || idRaw === undefined || idRaw === null) return null;

    const semanticHint = {
      nome: name,
      descricao: (isLegacyPixOnline ? 'Link com QR Code para o cliente no Pix' : labels.desc) || name
    };

    return {
      id: String(idRaw),
      name,
      desc: isLegacyPixOnline ? 'Link com QR Code para o cliente no Pix' : labels.desc,
      color: this.getPayColor(semanticHint),
      icon: this.getPayIcon(semanticHint),
      sectionKey,
      original: forma
    };
  }

  private normalizePayMethodLabels(forma: any): {name: string; desc: string | null} {
    const rawNome = this.cleanText(forma?.nome);
    const rawDesc = this.cleanText(forma?.descricao);

    const friendlyDesc = this.isFriendlyPayText(rawDesc) ? rawDesc : '';
    const friendlyNome = this.isFriendlyPayText(rawNome) ? rawNome : '';

    let name = friendlyDesc || friendlyNome;
    if (!name && rawDesc) name = this.humanizePayText(rawDesc);
    if (!name && rawNome) name = this.humanizePayText(rawNome);
    if (!name) name = 'Forma de pagamento';

    let desc: string | null = null;
    if (friendlyDesc && this.normalizeText(friendlyDesc) !== this.normalizeText(name)) {
      desc = friendlyDesc;
    } else if (friendlyNome && this.normalizeText(friendlyNome) !== this.normalizeText(name)) {
      desc = friendlyNome;
    }

    if (!desc) desc = this.getPayMethodFallbackDesc(name);
    if (desc && this.normalizeText(desc) === this.normalizeText(name)) {
      desc = null;
    }

    return {name, desc};
  }

  private cleanText(value: any): string {
    return (value || '').toString().trim();
  }

  private isFriendlyPayText(value: string): boolean {
    if (!value) return false;
    if (!this.normalizeText(value)) return false;
    return !this.isTechnicalPayText(value);
  }

  private isTechnicalPayText(value: string): boolean {
    const text = this.cleanText(value);
    if (!text) return false;

    const normalized = this.normalizeText(text);
    const noSpaces = !/\s/.test(text);
    const hasSeparator = /[_-]/.test(normalized);
    const compactCode = /^[a-z]{1,4}\d{2,}$/.test(normalized);

    return (hasSeparator && noSpaces) || compactCode;
  }

  private humanizePayText(value: string): string {
    const text = this.cleanText(value);
    if (!text) return '';

    const replaced = text
      .replace(/[_-]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();

    if (!replaced) return '';

    return replaced
      .split(' ')
      .map((part: string) => part ? part.charAt(0).toUpperCase() + part.slice(1).toLowerCase() : '')
      .join(' ');
  }

  private getPayMethodFallbackDesc(name: string): string | null {
    const normalized = this.normalizeText(name);
    if (normalized.includes('dinheiro')) return 'Pagamento em espécie';
    if (normalized.includes('pix') && normalized.includes('chave')) return 'Pagamento via chave Pix';
    if (normalized.includes('pix') && normalized.includes('maquininha')) return 'Pix na maquininha';
    if (normalized.includes('pix')) return 'QR Code gerado automaticamente';
    if (normalized.includes('vale') || normalized.includes('voucher')) return 'Alelo, Sodexo, VR';
    return null;
  }

  private buildPayMethodSections(methods: PayMethodVM[]): PayMethodSectionVM[] {
    const online = methods.filter((method) => method.sectionKey === 'online');
    const offline = methods.filter((method) => method.sectionKey === 'offline');
    const sections: PayMethodSectionVM[] = [
      {
        key: 'online',
        title: 'Pagamento Online',
        badge: 'Processado imediatamente',
        badgeColor: '#16a34a',
        methods: online
      },
      {
        key: 'offline',
        title: 'Na Entrega / Balcão',
        badge: 'Pague ao receber',
        badgeColor: '#ea580c',
        methods: offline
      }
    ];

    return sections.filter((section) => section.methods.length > 0);
  }

  private getPayColor(f: any): string {
    const nome = (f.nome || f.descricao || '').toLowerCase();
    if (nome.includes('pix') || nome.includes('dinheiro')) return '#16a34a';
    if (nome.includes('credito') || nome.includes('crédito')) return '#6366f1';
    if (nome.includes('debito') || nome.includes('débito')) return '#0891b2';
    if (nome.includes('vale') || nome.includes('voucher')) return '#7c3aed';
    return '#6366f1';
  }

  private getPayIcon(f: any): string {
    const nome = (f.nome || f.descricao || '').toLowerCase();
    if (nome.includes('pix')) return 'qr';
    if (nome.includes('dinheiro')) return 'banknote';
    if (nome.includes('vale') || nome.includes('voucher')) return 'wallet';
    return 'card';
  }

  isCustomizable(p: any): boolean {
    if (!p) return false;
    return (p.camposAdicionais && p.camposAdicionais.length > 0) ||
           (p.tamanhos && p.tamanhos.length > 0);
  }

  isProductCustomizable(p: any): boolean {
    return !!(p && (p._customizable || this.isCustomizable(p)));
  }

  // ==========================================
  // CATEGORIAS E BUSCA
  // ==========================================
  get filteredProducts() {
    let prods = this.produtos;
    if (this.activeCat && this.activeCat !== 'Todos') {
      const active = this.activeCat.trim();
      prods = prods.filter(p => {
        const catNome = p.categoria ? ((p.categoria.nome || p.categoria || '').toString().trim()) : '';
        return catNome === active;
      });
    }
    if (this.search && this.search.trim()) {
      const q = this.search.toLowerCase().trim();
      prods = prods.filter(p => {
        const nome = (p.nome || '').toLowerCase();
        const cod = (p.codigoPdv || p.codigo || p.id || '').toString().toLowerCase();
        return nome.includes(q) || cod.includes(q);
      });
    }
    return prods;
  }

  get categoryList() {
    return this._cachedCategoryList;
  }

  buildCategoryList() {
    const all = {nome: 'Todos', count: this.produtos.length, cor: '#6366f1', fundo: '#eef2ff'};
    const catColors = ['#7c3aed', '#ea580c', '#0891b2', '#db2777', '#6366f1', '#059669', '#d97706'];
    const catBgs = ['#f3e8ff', '#fff7ed', '#ecfeff', '#fdf2f8', '#eef2ff', '#ecfdf5', '#fffbeb'];
    const cats = this.categorias.map((c: any, i: number) => {
      const nome = (c.nome || c || '').toString().trim();
      const count = this.produtos.filter(p => {
        const cn = p.categoria ? ((p.categoria.nome || p.categoria || '').toString().trim()) : '';
        return cn === nome;
      }).length;
      return {nome, count, cor: catColors[i % catColors.length], fundo: catBgs[i % catBgs.length]};
    });
    this._cachedCategoryList = [all, ...cats];
  }

  selectCategory(cat: any) {
    this.activeCat = cat.nome;
  }

  trackByCat(index: number, cat: any): string {
    return cat.nome;
  }

  // ==========================================
  // ADICIONAR AO CARRINHO
  // ==========================================
  addToCart(product: any) {
    if (this.centralPedidosAtivo && !this.centralAtendimentoPreparado) {
      this.showUiErrorToast('Loja destino pendente', 'Selecione cliente e endereço para liberar o cardápio da loja destino.');
      return;
    }

    if (this.isProductCustomizable(product)) {
      this.openCustomize(product);
    } else {
      const item = this.buildCartItem(product, 1, [], null, null, '', 0);
      this.cart.push(item);
      this.syncPayMethodsWithCurrentTotal();
      this.scheduleDeliveryFeeRecalcFromCart();
    }
  }

  editCartItem(item: any) {
    this.editingItem = item;
    this.selProduct = item.product;
    this.qty = item.qty;
    this.selExtras = {};
    this.selSingleChoices = {};
    this.fieldErrors = {};
    this.fieldShakeKey = {};
    this.restoreSelectionsFromItem(item);
    this.selCalda = item.calda;
    this.colher = item.colher;
    this.obs = item.obs;
    this.discount = item.disc ? item.disc.toString() : '';
    this.errors = {};
    this.fieldErrors = {};
    this.fieldShakeKey = {};
    this.applyDefaultSingleSelections();

    if (this.isMobile) {
      this.mCustomizeOpen = true;
    } else {
      this.sbVis = true;
    }
  }

  openCustomize(product: any) {
    this.selProduct = product;
    this.editingItem = null;
    this.qty = 1;
    this.selExtras = {};
    this.selSingleChoices = {};
    this.selCalda = null;
    this.colher = null;
    this.obs = '';
    this.discount = '';
    this.errors = {};
    this.fieldErrors = {};
    this.fieldShakeKey = {};
    this.applyDefaultSingleSelections();

    if (this.isMobile) {
      this.mCustomizeOpen = true;
    } else {
      this.sbVis = true;
    }
  }

  closeCustomize() {
    this.sbVis = false;
    this.mCustomizeOpen = false;
    setTimeout(() => {
      this.selProduct = null;
      this.editingItem = null;
    }, 250);
  }

  private normalizeText(value: any): string {
    return (value || '')
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  private isExplicitTrue(value: any): boolean {
    if (value === true || value === 1 || value === '1') return true;
    const normalized = this.normalizeText(value);
    return normalized === 'true' || normalized === 'sim' || normalized === 'yes' || normalized === 'on';
  }

  private isExplicitFalse(value: any): boolean {
    if (value === false || value === 0 || value === '0') return true;
    const normalized = this.normalizeText(value);
    return normalized === 'false' || normalized === 'nao' || normalized === 'no' || normalized === 'off';
  }

  private getCampoOptionsSource(adic: any): any[] {
    if (!adic) return [];
    if (Array.isArray(adic.opcoesDisponiveis)) return adic.opcoesDisponiveis;
    if (Array.isArray(adic.opcoes)) return adic.opcoes;
    if (Array.isArray(adic.opcoesDoCampo)) return adic.opcoesDoCampo;
    return [];
  }

  private getOptionDependencies(option: any): any[] {
    if (!option) return [];
    if (Array.isArray(option.dependencias)) return option.dependencias;
    if (Array.isArray(option.dependencies)) return option.dependencies;
    return [];
  }

  private isDependencySelected(dependency: any): boolean {
    const adicionalId = dependency?.adicionalId ?? dependency?.adicional?.id ?? dependency?.campoAdicionalId;
    const optionId =
      dependency?.opcaoDependente?.id ??
      dependency?.opcaoDependenteId ??
      dependency?.opcaoId ??
      dependency?.opcao?.id;

    if (adicionalId === undefined || adicionalId === null || optionId === undefined || optionId === null) {
      return false;
    }

    const fieldKey = 'f:' + String(adicionalId);
    const optionSuffix = ':o:' + String(optionId);
    const optionKey = fieldKey + optionSuffix;

    if ((this.selExtras[optionKey] || 0) > 0) return true;
    if (this.selSingleChoices[fieldKey] === optionKey) return true;

    const selectedByQty = Object.entries(this.selExtras || {})
      .some(([key, qty]) => Number(qty || 0) > 0 && String(key).endsWith(optionSuffix));
    if (selectedByQty) return true;

    return Object.values(this.selSingleChoices || {})
      .some((value: any) => String(value || '').endsWith(optionSuffix));
  }

  private isOptionVisible(option: any): boolean {
    if (!option) return false;
    if (this.isExplicitFalse(option.disponivel)) return false;
    if (this.isExplicitTrue(option.oculta) || this.isExplicitTrue(option.oculto)) return false;

    const dependencies = this.getOptionDependencies(option);
    if (dependencies.length) {
      return dependencies.some((dependency: any) => this.isDependencySelected(dependency));
    }

    if (this.isExplicitTrue(option.esconder) || this.isExplicitTrue(option.escondido)) return false;
    return true;
  }

  private getSelProductCampos(product: any = this.selProduct): any[] {
    if (!product || !product.camposAdicionais) return [];
    return product.camposAdicionais
      .filter((adic: any) => !!(adic && this.getCampoOptionsSource(adic).length));
  }

  private isCaldaField(adic: any): boolean {
    const nome = this.normalizeText(adic?.nome);
    if (!nome.includes('calda')) return false;
    const tipo = this.normalizeText(adic?.tipo || adic?.classe);
    if (tipo.includes('multipla')) return false;
    const max = Number(adic?.qtdMaxima || 0);
    if (max > 1) return false;
    return true;
  }

  private isColherField(adic: any): boolean {
    const nome = this.normalizeText(adic?.nome);
    return nome.includes('colher');
  }

  private isSimNaoField(adic: any): boolean {
    const options = this.getCampoOptionsSource(adic)
      .map((op: any) => this.normalizeText(op?.nome || op?.descricao))
      .filter((n: string) => !!n);
    return options.includes('sim') && options.includes('nao');
  }

  private getFieldKey(adic: any, index: number): string {
    const id = adic?.id;
    if (id !== null && id !== undefined && id !== '') {
      return 'f:' + String(id);
    }
    return 'fn:' + this.normalizeText(adic?.nome || 'campo') + ':' + String(index);
  }

  private getOptionKey(option: any, fieldKey: string): string {
    const id = option?.id ?? option?.opcaoId;
    if (id !== null && id !== undefined && id !== '') {
      return fieldKey + ':o:' + String(id);
    }
    return fieldKey + ':n:' + this.normalizeText(option?.nome || option?.descricao || option?.name || '');
  }

  private mapCampoOptions(adic: any, fieldKey: string = 'field'): any[] {
    const source = this.getCampoOptionsSource(adic);
    if (!source.length) return [];
    return source
      .filter((op: any) => this.isOptionVisible(op))
      .map((op: any) => ({
        id: op.id,
        name: op.nome || op.descricao,
        price: Number(op.valor ?? op.preco ?? 0),
        groupName: adic.nome,
        fieldId: adic.id,
        fieldKey,
        optionKey: this.getOptionKey(op, fieldKey)
      }));
  }

  private classifyAdicionalKind(adic: any): 'repeat' | 'multi' | 'single' {
    const repeatable = this.isExplicitTrue(adic?.podeRepetirItem);
    const tipo = this.normalizeText(adic?.tipo || adic?.classe);
    if (tipo.includes('multipla') && repeatable) return 'repeat';
    if (tipo.includes('multipla')) return 'multi';
    if (tipo.includes('escolha-simples')) return 'single';
    const max = Number(adic?.qtdMaxima || 0);
    const min = Number(adic?.qtdMinima || 0);
    if (repeatable) return 'repeat';
    if (max === 1) return 'single';
    if (max > 1 || min > 1) return 'multi';
    return 'multi';
  }

  private getAdditionalFieldsForProduct(product: any): any[] {
    const campos = this.getSelProductCampos(product);
    const fields: any[] = [];
    campos.forEach((adic: any, index: number) => {
      const fieldKey = this.getFieldKey(adic, index);
      const options = this.mapCampoOptions(adic, fieldKey);
      if (!options.length) return;
      const kind = this.classifyAdicionalKind(adic);
      const rawMin = Number(adic.qtdMinima || 0);
      const rawMax = Number(adic.qtdMaxima || 0);
      const max = rawMax > 0 ? rawMax : (kind === 'single' ? 1 : options.length);
      fields.push({
        id: adic.id,
        fieldKey,
        name: adic.nome || 'Adicional',
        required: this.isExplicitTrue(adic.obrigatorio),
        min: rawMin,
        max,
        type: adic.tipo || adic.classe,
        repeatable: this.isExplicitTrue(adic.podeRepetirItem),
        kind,
        raw: adic,
        options
      });
    });
    return fields;
  }

  private applyDefaultSingleSelections() {
    const next = {...this.selSingleChoices};
    let changed = false;
    for (const field of this.selProductOrderedFields) {
      if (field.kind !== 'single') continue;
      if (next[field.fieldKey]) continue;
      if (field.options.length === 1 && (field.required || Number(field.min || 0) > 0)) {
        next[field.fieldKey] = field.options[0].optionKey;
        changed = true;
      }
    }
    if (changed) this.selSingleChoices = next;
  }

  private get currentAdditionalFields(): any[] {
    return this.getAdditionalFieldsForProduct(this.selProduct);
  }

  get selProductOrderedFields(): any[] {
    return this.currentAdditionalFields;
  }

  get selProductRepeatFields(): any[] {
    return this.currentAdditionalFields.filter((f: any) => f.kind === 'repeat');
  }

  get selProductMultiFields(): any[] {
    return this.currentAdditionalFields.filter((f: any) => f.kind === 'multi');
  }

  get selProductSingleFields(): any[] {
    return this.currentAdditionalFields.filter((f: any) => f.kind === 'single');
  }

  get selProductExtras(): any[] {
    const extras: any[] = [];
    for (const field of this.selProductRepeatFields) {
      extras.push(...field.options);
    }
    return extras;
  }

  private findCaldaField(product: any = this.selProduct): any {
    const campos = this.getSelProductCampos(product);
    return campos.find((adic: any) => this.isCaldaField(adic)) || null;
  }

  private findColherField(product: any = this.selProduct): any {
    const campos = this.getSelProductCampos(product);
    const byName = campos.find((adic: any) => this.isColherField(adic));
    if (byName) return byName;
    return campos.find((adic: any) =>
      this.isSimNaoField(adic) && this.normalizeText(adic?.nome).includes('descart')
    ) || null;
  }

  get selProductCaldas(): any[] {
    const field = this.findCaldaField();
    if (!field) return [];
    return this.mapCampoOptions(field, this.getFieldKey(field, 0));
  }

  get selProductHasColher(): boolean {
    return !!this.findColherField();
  }

  get selProductColherOptions(): string[] {
    const campoColher = this.findColherField();
    if (!campoColher) return [];

    const options = this.mapCampoOptions(campoColher, this.getFieldKey(campoColher, 0))
      .map((op: any) => (op.name || '').toString().trim())
      .filter((name: string) => !!name);

    if (options.length) return options;
    return ['Sim', 'Não'];
  }

  private getExtraKey(extra: any): string {
    if (extra?.optionKey) return String(extra.optionKey);
    const id = extra?.id ?? extra?.opcaoId ?? extra?.codigo;
    const fieldKey = extra?.fieldKey || extra?.groupName || '';
    if (id !== null && id !== undefined && id !== '') {
      return String(fieldKey) + ':id:' + String(id);
    }
    const group = (extra?.groupName || extra?.grupo || '').toString();
    const name = (extra?.name || extra?.nome || '').toString();
    return 'nm:' + group + ':' + name;
  }

  private setExtraQtyByKey(key: string, value: number) {
    const updated = {...this.selExtras};
    if (value <= 0) {
      delete updated[key];
    } else {
      updated[key] = value;
    }
    this.selExtras = updated;
  }

  getRepeatQty(field: any, option: any): number {
    const key = option?.optionKey || this.getOptionKey(option, field?.fieldKey || 'field');
    return this.selExtras[key] || 0;
  }

  changeRepeatQty(field: any, option: any, delta: number) {
    if (!field || !option || delta === 0) return;
    const key = option.optionKey;
    const current = this.selExtras[key] || 0;
    const total = this.getFieldSelectedTotal(field);
    const max = Number(field.max || 0);
    if (delta > 0 && max > 0 && total >= max) return;
    const next = Math.max(0, current + delta);
    this.setExtraQtyByKey(key, next);
    this.clearFieldError(field);
  }

  isMultiSelected(field: any, option: any): boolean {
    const key = option?.optionKey || this.getOptionKey(option, field?.fieldKey || 'field');
    return (this.selExtras[key] || 0) > 0;
  }

  toggleMultiChoice(field: any, option: any) {
    if (!field || !option) return;
    const key = option.optionKey;
    const selected = this.isMultiSelected(field, option);
    if (selected) {
      this.setExtraQtyByKey(key, 0);
    } else {
      const total = this.getFieldSelectedTotal(field);
      const max = Number(field.max || 0);
      if (max > 0 && total >= max) return;
      this.setExtraQtyByKey(key, 1);
    }
    this.clearFieldError(field);
  }

  isSingleSelected(field: any, option: any): boolean {
    return this.selSingleChoices[field?.fieldKey] === option?.optionKey;
  }

  selectSingleChoice(field: any, option: any) {
    this.selSingleChoices = {
      ...this.selSingleChoices,
      [field.fieldKey]: option.optionKey
    };
    this.clearFieldError(field);
  }

  getFieldSelectedTotal(field: any): number {
    if (!field) return 0;
    if (field.kind === 'single') {
      return this.selSingleChoices[field.fieldKey] ? 1 : 0;
    }
    return field.options.reduce((sum: number, option: any) => sum + (this.selExtras[option.optionKey] || 0), 0);
  }

  getFieldCounterText(field: any): string {
    const selected = this.getFieldSelectedTotal(field);
    if (field.kind === 'single') return selected ? '1/1' : '0/1';
    const max = Number(field.max || 0);
    return max > 0 ? `${selected}/${max}` : `${selected} selecionados`;
  }

  isFieldCounterActive(field: any): boolean {
    return this.getFieldSelectedTotal(field) > 0;
  }

  fieldHasError(field: any): boolean {
    return !!this.fieldErrors[field?.fieldKey];
  }

  fieldErrorText(field: any): string {
    return this.fieldErrors[field?.fieldKey] || '';
  }

  getFieldShakeKey(field: any): number {
    return this.fieldShakeKey[field?.fieldKey] || 0;
  }

  private buildFieldSelector(fieldKey: string): string {
    const safe = String(fieldKey || '').replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    return `[data-field-key="${safe}"]`;
  }

  private bumpFieldShake(field: any) {
    const fieldKey = field?.fieldKey;
    if (!fieldKey) return;

    this.fieldShakeKey = {
      ...this.fieldShakeKey,
      [fieldKey]: (this.fieldShakeKey[fieldKey] || 0) + 1
    };

    requestAnimationFrame(() => {
      const el = document.querySelector(this.buildFieldSelector(fieldKey)) as HTMLElement;
      if (!el) return;
      el.classList.remove('sb-field-shake');
      void el.offsetWidth;
      el.classList.add('sb-field-shake');
    });
  }

  private getScrollableAncestor(el: HTMLElement | null): HTMLElement | null {
    let cur = el?.parentElement || null;
    while (cur) {
      const style = window.getComputedStyle(cur);
      const overflowY = style.overflowY;
      const canScrollY = (overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay')
        && cur.scrollHeight > cur.clientHeight;
      if (canScrollY) return cur;
      cur = cur.parentElement;
    }
    return null;
  }

  private waitForScrollEnd(scroller: HTMLElement | null, done: () => void) {
    const startedAt = performance.now();
    const maxWaitMs = 900;
    const stableFramesNeeded = 5;
    let stableFrames = 0;
    let lastPos = scroller ? scroller.scrollTop : window.scrollY;

    const tick = () => {
      const nowPos = scroller ? scroller.scrollTop : window.scrollY;
      if (Math.abs(nowPos - lastPos) < 0.5) {
        stableFrames += 1;
      } else {
        stableFrames = 0;
      }
      lastPos = nowPos;

      if (stableFrames >= stableFramesNeeded || (performance.now() - startedAt) > maxWaitMs) {
        done();
        return;
      }

      requestAnimationFrame(tick);
    };

    requestAnimationFrame(tick);
  }

  private scrollToField(field: any, onDone?: () => void) {
    const fieldKey = field?.fieldKey;
    if (!fieldKey) {
      if (onDone) onDone();
      return;
    }

    requestAnimationFrame(() => {
      const el = document.querySelector(this.buildFieldSelector(fieldKey)) as HTMLElement;
      if (!el) {
        if (onDone) onDone();
        return;
      }

      const scroller = this.getScrollableAncestor(el);
      el.scrollIntoView({behavior: 'smooth', block: 'center', inline: 'nearest'});

      const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion) {
        if (onDone) onDone();
        return;
      }

      this.waitForScrollEnd(scroller, () => {
        if (onDone) onDone();
      });
    });
  }

  private clearFieldError(field: any) {
    if (!field) return;

    if (this.fieldErrors[field.fieldKey]) {
      const updated = {...this.fieldErrors};
      delete updated[field.fieldKey];
      this.fieldErrors = updated;
    }

    const el = document.querySelector(this.buildFieldSelector(field.fieldKey)) as HTMLElement;
    if (el) el.classList.remove('sb-field-shake');
  }

  get selectedExtrasCount(): number {
    const fields = this.currentAdditionalFields;
    return fields.reduce((sum: number, field: any) => sum + this.getFieldSelectedTotal(field), 0);
  }

  toggleCalda(calda: any) {
    if (this.selCalda && this.selCalda.id === calda.id) {
      this.selCalda = null;
    } else {
      this.selCalda = calda;
    }
  }

  get customizeTotal(): number {
    if (!this.selProduct) return 0;
    const basePrice = this.selProduct.preco || this.selProduct.valor || 0;
    let extrasTotal = 0;
    for (const ext of this.collectSelectedExtras()) {
      const qty = ext.qty || 0;
      extrasTotal += ext.price * qty;
    }
    const unitPrice = basePrice + extrasTotal;
    const disc = parseFloat(this.discount) || 0;
    return Math.max(0, Math.round((unitPrice * this.qty - disc) * 100) / 100);
  }

  private validateAdditionalFields(): boolean {
    const errors: any = {};
    for (const field of this.currentAdditionalFields) {
      const selected = this.getFieldSelectedTotal(field);
      if (field.kind === 'single') {
        if (field.required && !this.selSingleChoices[field.fieldKey]) {
          errors[field.fieldKey] = 'Selecione uma opção';
        }
        continue;
      }
      const minFromField = Number(field.min || 0);
      const min = Math.max(minFromField, field.required ? 1 : 0);
      const max = Number(field.max || 0);
      if (selected < min) {
        errors[field.fieldKey] = `Selecione no mínimo ${min}`;
      } else if (max > 0 && selected > max) {
        errors[field.fieldKey] = `Selecione no máximo ${max}`;
      }
    }
    this.fieldErrors = errors;
    return Object.keys(errors).length === 0;
  }

  private createCartExtra(field: any, option: any, qty: number): any {
    return {
      id: option.id,
      name: option.name,
      price: option.price,
      qty,
      fieldId: field.id,
      fieldKey: field.fieldKey,
      fieldName: field.name,
      fieldKind: field.kind,
      fieldType: field.type,
      optionKey: option.optionKey
    };
  }

  private collectSelectedExtras(): any[] {
    const extras: any[] = [];
    for (const field of this.currentAdditionalFields) {
      if (field.kind === 'single') {
        const selectedKey = this.selSingleChoices[field.fieldKey];
        if (!selectedKey) continue;
        const selectedOption = field.options.find((option: any) => option.optionKey === selectedKey);
        if (selectedOption) {
          extras.push(this.createCartExtra(field, selectedOption, 1));
        }
        continue;
      }
      for (const option of field.options) {
        const qty = this.selExtras[option.optionKey] || 0;
        if (qty <= 0) continue;
        extras.push(this.createCartExtra(field, option, qty));
      }
    }
    return extras;
  }

  private findFieldOptionForExtra(extra: any, fields: any[]): any {
    if (!extra || !fields.length) return null;
    const normalizedName = this.normalizeText(extra.name || extra.nome);

    if (extra.fieldKey) {
      const byFieldKey = fields.find((field: any) => field.fieldKey === extra.fieldKey);
      if (byFieldKey) {
        const option = byFieldKey.options.find((op: any) =>
          (extra.optionKey && op.optionKey === extra.optionKey) ||
          (extra.id !== undefined && extra.id !== null && op.id === extra.id) ||
          (normalizedName && this.normalizeText(op.name) === normalizedName)
        );
        if (option) return {field: byFieldKey, option};
      }
    }

    if (extra.fieldId !== undefined && extra.fieldId !== null) {
      const byFieldId = fields.find((field: any) => field.id === extra.fieldId);
      if (byFieldId) {
        const option = byFieldId.options.find((op: any) =>
          (extra.id !== undefined && extra.id !== null && op.id === extra.id) ||
          (normalizedName && this.normalizeText(op.name) === normalizedName)
        );
        if (option) return {field: byFieldId, option};
      }
    }

    for (const field of fields) {
      const option = field.options.find((op: any) =>
        (extra.id !== undefined && extra.id !== null && op.id === extra.id) ||
        (normalizedName && this.normalizeText(op.name) === normalizedName)
      );
      if (option) return {field, option};
    }

    return null;
  }

  private restoreSelectionsFromItem(item: any) {
    this.selExtras = {};
    this.selSingleChoices = {};
    const fields = this.currentAdditionalFields;
    if (!item || !item.extras || !fields.length) return;

    const restoredExtras: any = {};
    const restoredSingles: any = {};
    for (const extra of item.extras) {
      const matched = this.findFieldOptionForExtra(extra, fields);
      if (!matched) continue;
      const field = matched.field;
      const option = matched.option;
      if (field.kind === 'single') {
        restoredSingles[field.fieldKey] = option.optionKey;
      } else if (field.kind === 'multi') {
        restoredExtras[option.optionKey] = (extra.qty || 0) > 0 ? 1 : 0;
      } else {
        restoredExtras[option.optionKey] = Math.max(0, Number(extra.qty || 0));
      }
    }
    this.selExtras = restoredExtras;
    this.selSingleChoices = restoredSingles;
  }

  confirmCustomize() {
    this.errors = {};
    if (!this.validateAdditionalFields()) {
      const firstInvalid = this.selProductOrderedFields.find((field: any) => this.fieldHasError(field));
      if (firstInvalid) {
        this.scrollToField(firstInvalid, () => {
          this.bumpFieldShake(firstInvalid);
        });
      }
      return;
    }

    const extras = this.collectSelectedExtras();

    if (this.editingItem) {
      const idx = this.cart.findIndex(c => c.id === this.editingItem.id);
      if (idx !== -1) {
        const newItem = this.buildCartItem(
          this.selProduct, this.qty, extras, this.selCalda, this.colher, this.obs, parseFloat(this.discount) || 0
        );
        newItem.id = this.editingItem.id;
        this.cart[idx] = newItem;
      }
    } else {
      const item = this.buildCartItem(
        this.selProduct, this.qty, extras, this.selCalda, this.colher, this.obs, parseFloat(this.discount) || 0
      );
      this.cart.push(item);
    }

    this.closeCustomize();
    this.scheduleDeliveryFeeRecalcFromCart();

    if (this.isMobile) {
      setTimeout(() => {
        this.mCartOpen = true;
        this.mCustomizeOpen = false;
      }, 300);
    }
  }

  private buildCartItem(product: any, qty: number, extras: any[], calda: any, colher: string, obs: string, disc: number) {
    const basePrice = product.preco || product.valor || 0;
    let extrasTotal = 0;
    for (const e of extras) {
      extrasTotal += e.price * e.qty;
    }
    const up = Math.round((basePrice + extrasTotal) * 100) / 100;
    const total = Math.max(0, Math.round((up * qty - disc) * 100) / 100);
    return {
      id: Date.now(),
      pid: product.id,
      name: product.nome,
      qty,
      up,
      total,
      extras,
      calda,
      colher,
      obs,
      disc,
      product
    };
  }

  // ==========================================
  // CARRINHO OPERACOES
  // ==========================================
  get cartTotal(): number {
    let total = this.cart.reduce((sum, item) => sum + item.total, 0);
    const fee = parseFloat(this.deliveryFee) || 0;
    if (this.isDeliveryMode) total += fee;
    return Math.round(total * 100) / 100;
  }

  get cartSubtotal(): number {
    return Math.round(this.cart.reduce((sum, item) => sum + item.total, 0) * 100) / 100;
  }

  updateCartQty(item: any, delta: number) {
    item.qty = Math.max(1, item.qty + delta);
    const disc = item.disc || 0;
    item.total = Math.max(0, Math.round((item.up * item.qty - disc) * 100) / 100);
    this.syncPayMethodsWithCurrentTotal();
    this.scheduleDeliveryFeeRecalcFromCart();
  }

  removeCartItem(item: any) {
    this.cart = this.cart.filter(c => c.id !== item.id);
    this.syncPayMethodsWithCurrentTotal();
    this.scheduleDeliveryFeeRecalcFromCart();
  }

  getExtrasText(item: any): string {
    if (!item.extras || !item.extras.length) return '';
    return item.extras.map(e => `${e.qty}x ${e.name}`).join(', ');
  }

  // ==========================================
  // CENTRAL DE PEDIDOS
  // ==========================================
  get centralPedidosPodeOperar(): boolean {
    return !!this.centralPedidosContexto?.podeAcessar;
  }

  get centralPedidosBloqueada(): boolean {
    return this.centralPedidosAtivo && !this.centralAtendimentoPreparado;
  }

  get centralPedidosLojasParticipantes(): any[] {
    return this.centralPedidosContexto?.lojas || [];
  }

  get centralPedidosGrupoDeLojasId(): number | undefined {
    return Number(this.centralPedidosContexto?.grupoDeLojasId || 0) || undefined;
  }

  get centralPedidosLojasOrdenadas(): any[] {
    return (this.centralPedidosLojasParticipantes || [])
      .filter((loja: any) => this.valorCentralBooleano(loja?.ativa))
      .slice()
      .sort((a: any, b: any) => {
        const deliveryA = this.valorCentralBooleano(a?.deliveryAtivo) ? 0 : 1;
        const deliveryB = this.valorCentralBooleano(b?.deliveryAtivo) ? 0 : 1;
        if (deliveryA !== deliveryB) return deliveryA - deliveryB;

        const retiradaA = this.valorCentralBooleano(a?.retiradaAtiva) ? 0 : 1;
        const retiradaB = this.valorCentralBooleano(b?.retiradaAtiva) ? 0 : 1;
        if (retiradaA !== retiradaB) return retiradaA - retiradaB;

        return (a?.nome || '').localeCompare(b?.nome || '');
      });
  }

  lojaCentralTemDelivery(loja: any): boolean {
    return this.valorCentralBooleano(loja?.deliveryAtivo);
  }

  lojaCentralTemRetirada(loja: any): boolean {
    return this.valorCentralBooleano(loja?.retiradaAtiva);
  }

  private partesComunsLojasCache: { chave: string; prefixo: string; sufixo: string } = { chave: '', prefixo: '', sufixo: '' };

  private get partesComunsDasLojasOrdenadas(): { prefixo: string; sufixo: string } {
    const nomes = this.centralPedidosLojasOrdenadas.map((loja: any) => (loja?.nome || '').toString());
    const chave = nomes.join('|');
    if (this.partesComunsLojasCache.chave === chave) return this.partesComunsLojasCache;

    let prefixo = '';
    let sufixo = '';
    if (nomes.length >= 2) {
      prefixo = this.calculePrefixoComumLojas(nomes);
      sufixo = this.calculeSufixoComumLojas(nomes, prefixo);
    }
    if (prefixo.length < 8) prefixo = '';
    if (sufixo.length < 8) sufixo = '';

    this.partesComunsLojasCache = { chave, prefixo, sufixo };
    return this.partesComunsLojasCache;
  }

  getNomeLojaPartes(loja: any): { prefixo: string; destaque: string; sufixo: string } {
    const nome = (loja?.nome || '').toString();
    const { prefixo, sufixo } = this.partesComunsDasLojasOrdenadas;
    if (!prefixo && !sufixo) return { prefixo: '', destaque: nome, sufixo: '' };

    let destaque = nome;
    if (prefixo && destaque.startsWith(prefixo)) destaque = destaque.slice(prefixo.length);
    if (sufixo && destaque.endsWith(sufixo)) destaque = destaque.slice(0, destaque.length - sufixo.length);

    if (!destaque.trim()) return { prefixo: '', destaque: nome, sufixo: '' };
    return { prefixo, destaque, sufixo };
  }

  private calculePrefixoComumLojas(nomes: string[]): string {
    const primeiro = nomes[0];
    let i = 0;
    while (i < primeiro.length && nomes.every(n => n.charAt(i) === primeiro.charAt(i))) i++;
    return primeiro.slice(0, i);
  }

  private calculeSufixoComumLojas(nomes: string[], prefixo: string): string {
    const primeiro = nomes[0];
    const limite = primeiro.length - prefixo.length;
    let i = 0;
    while (i < limite && nomes.every(n => n.charAt(n.length - 1 - i) === primeiro.charAt(primeiro.length - 1 - i))) i++;
    return primeiro.slice(primeiro.length - i);
  }

  get centralPedidosBuscaExecutada(): boolean {
    return !!this.centralPedidosBuscaUltimoTermo
      && (this.centralPedidosBusca || '').trim() === this.centralPedidosBuscaUltimoTermo;
  }

  isLojaCentralSelecionada(loja: any): boolean {
    const lojaSelecionadaId = this.centralPedidosLojaDestino?.id || this.centralPedidosLojaDestino?.empresaId;
    const lojaId = loja?.id || loja?.empresaId;
    return !!this.centralPedidosLojaManual && String(lojaSelecionadaId || '') === String(lojaId || '');
  }

  private centralLojaManualCarregada(): boolean {
    return this.centralPedidosAtivo
      && this.centralAtendimentoPreparado
      && this.centralPedidosLojaManual
      && !!this.centralPedidosLojaDestino;
  }

  private limpeClientePedidoCentralPreservandoLojaManual(limparClienteCentral: boolean = false) {
    if (limparClienteCentral) {
      this.centralPedidosClienteSelecionado = null;
    }
    this.centralPedidosEnderecos = [];
    this.centralPedidosEnderecoSelecionado = null;
    this.centralPedidosEntrega = null;
    this.selectedContact = null;
    this.selectedAddress = null;
    this.customerName = '';
    this.customerPhone = '';
    this.customerAddress = '';
    this.deliveryFee = '';
    this.deliveryFeeError = '';
    this.deliveryFeeLoading = false;
    this.payAddressRequirementTouched = false;
  }

  carregueCentralPedidos() {
    if (!this.centralPedidosAtivo) return;

    this.centralPedidosCarregando = true;
    this.centralPedidosErro = '';
    this.grupolojasService.obtenhaCentralPedidos().then((contexto: any) => {
      this.centralPedidosContexto = contexto || {};
      if (!this.centralPedidosContexto.podeAcessar) {
        this.centralPedidosErro = this.centralPedidosContexto.motivoBloqueio || 'Usuário sem permissão para operar a Central de Pedidos.';
      }
    }).catch((erro: any) => {
      this.centralPedidosErro = this.extractErrorText(erro, 'Não foi possível carregar a Central de Pedidos.');
    }).finally(() => {
      this.centralPedidosCarregando = false;
    });
  }

  busqueClientesCentralPedidos() {
    this.clearCentralPedidosBuscaTimer();
    this.executeBuscaClientesCentralPedidos((this.centralPedidosBusca || '').trim());
  }

  private agendeBuscaClientesCentralPedidos() {
    this.clearCentralPedidosBuscaTimer();

    const termo = (this.centralPedidosBusca || '').trim();
    const reqId = ++this.centralPedidosBuscaReqSeq;

    if (termo.length < 2) {
      this.centralPedidosBuscando = false;
      this.centralPedidosErro = '';
      this.centralPedidosClientes = [];
      this.centralPedidosClientesAgrupados = [];
      if (!this.centralPedidosModoTrocaCliente) {
        this.centralPedidosClienteSelecionado = null;
        this.centralPedidosEnderecos = [];
      }
      this.centralPedidosBuscaUltimoTermo = '';
      if (!this.centralPedidosModoTrocaCliente) {
        if (this.centralLojaManualCarregada()) {
          this.limpeClientePedidoCentralPreservandoLojaManual(true);
        } else {
          this.limpeAtendimentoCentralResolvido(true, true);
        }
      }
      return;
    }

    this.centralPedidosBuscaTimer = setTimeout(() => {
      this.centralPedidosBuscaTimer = null;
      if (reqId !== this.centralPedidosBuscaReqSeq) return;
      this.executeBuscaClientesCentralPedidos(termo, reqId);
    }, 300);
  }

  private executeBuscaClientesCentralPedidos(termo: string, reqId?: number) {
    const termoNormalizado = (termo || '').trim();
    if (!this.centralPedidosPodeOperar || termoNormalizado.length < 2) return;

    if (!this.centralPedidosErro && termoNormalizado === this.centralPedidosBuscaUltimoTermo) {
      return;
    }

    const requestId = reqId || ++this.centralPedidosBuscaReqSeq;
    this.abraDialogCentralPedidosComProtecao();
    this.centralPedidosBuscando = true;
    this.centralPedidosErro = '';
    this.centralPedidosClientes = [];
    this.centralPedidosClientesAgrupados = [];
    if (!this.centralPedidosModoTrocaCliente) {
      this.centralPedidosClienteSelecionado = null;
      this.centralPedidosEnderecos = [];
      if (this.centralLojaManualCarregada()) {
        this.limpeClientePedidoCentralPreservandoLojaManual(true);
      } else {
        this.limpeAtendimentoCentralResolvido(true, true);
      }
    }

    this.grupolojasService.busqueClientesCentralPedidos(termoNormalizado, this.centralPedidosGrupoDeLojasId).then((resposta: any) => {
      if (requestId !== this.centralPedidosBuscaReqSeq) return;
      this.centralPedidosClientes = this.filtreClientesPelaLojaDestino(resposta?.clientes || []);
      this.centralPedidosClientesAgrupados = this.agrupeClientesCentral(this.centralPedidosClientes);
      this.centralPedidosBuscaUltimoTermo = termoNormalizado;
    }).catch((erro: any) => {
      if (requestId !== this.centralPedidosBuscaReqSeq) return;
      this.centralPedidosErro = this.extractErrorText(erro, 'Não foi possível buscar clientes na Central.');
      this.centralPedidosBuscaUltimoTermo = '';
    }).finally(() => {
      if (requestId !== this.centralPedidosBuscaReqSeq) return;
      this.centralPedidosBuscando = false;
    });
  }

  private confirmeDescartoCarrinho(motivo: 'loja' | 'cliente' | 'endereco'): boolean {
    if (!this.centralAtendimentoPreparado) return true;
    const itens = this.cart?.length || 0;
    if (itens === 0) return true;

    const sufixo = `Vai descartar ${itens} item(ns) já adicionado(s) ao carrinho. Confirmar?`;
    const mensagens = {
      loja: `Trocar de loja muda o cardápio. ${sufixo}`,
      cliente: `Trocar de cliente reinicia o atendimento. ${sufixo}`,
      endereco: `Mudar o endereço pode resolver outra loja. ${sufixo}`
    };

    return window.confirm(mensagens[motivo]);
  }

  selecioneClienteCentralPedidos(cliente: any) {
    if (!cliente || this.centralPedidosBuscando || this.centralPedidosCriandoCliente) return;

    const clienteAtualId = this.centralPedidosClienteSelecionado?.contatoId || this.centralPedidosClienteSelecionado?.id;
    const clienteNovoId = cliente?.contatoId || cliente?.id;
    const trocouCliente = !!clienteAtualId && String(clienteAtualId) !== String(clienteNovoId);
    const preservaCarrinho = this.centralLojaManualCarregada();
    if (trocouCliente && !preservaCarrinho && !this.confirmeDescartoCarrinho('cliente')) return;

    this.centralPedidosModoTrocaCliente = false;
    this.centralPedidosClienteSelecionado = cliente;
    this.centralPedidosEnderecos = [];
    this.centralPedidosEnderecoSelecionado = null;
    if (preservaCarrinho) {
      this.limpeClientePedidoCentralPreservandoLojaManual(false);
    } else {
      this.limpeAtendimentoCentralResolvido(true, true);
    }
    this.centralPedidosErro = '';

    this.grupolojasService.selecioneClienteCentralPedidos(cliente.empresaId, cliente.contatoId, this.centralPedidosGrupoDeLojasId).then((resposta: any) => {
      this.centralPedidosClienteSelecionado = resposta?.cliente || cliente;
      this.centralPedidosEnderecos = resposta?.enderecos || [];
    }).catch((erro: any) => {
      this.centralPedidosErro = this.extractErrorText(erro, 'Não foi possível selecionar o cliente.');
    });
  }

  crieClienteCentralPedidos(dados: any) {
    if (!this.centralPedidosAtivo || !this.centralPedidosPodeOperar || this.centralPedidosCriandoCliente) return;

    const preservaCarrinho = this.centralLojaManualCarregada();
    if (!preservaCarrinho && !this.confirmeDescartoCarrinho('cliente')) return;

    this.centralPedidosCriandoCliente = true;
    this.centralPedidosErro = '';
    if (preservaCarrinho) {
      this.limpeClientePedidoCentralPreservandoLojaManual(true);
    } else {
      this.limpeAtendimentoCentralResolvido(true, true);
    }

    this.grupolojasService.crieClienteCentralPedidos(dados, this.centralPedidosGrupoDeLojasId).then((resposta: any) => {
      const cliente = resposta?.cliente;
      if (!cliente) {
        this.centralPedidosErro = 'Cliente criado, mas não foi possível carregar o cadastro na Central.';
        return;
      }

      this.centralPedidosClienteSelecionado = cliente;
      this.centralPedidosModoTrocaCliente = false;
      this.centralPedidosEnderecos = resposta?.enderecos || [];
      this.centralPedidosEnderecoSelecionado = null;
      this.centralPedidosBusca = cliente.telefone || dados?.telefone || '';
      this.centralPedidosClientes = [cliente];
      this.centralPedidosClientesAgrupados = this.agrupeClientesCentral(this.centralPedidosClientes);
      this.definaLojaAtendimentoCadastroCliente(dados?.empresaOrigemId);
      this.prepareLojaAtendimentoAposCadastroCliente();
    }).catch((erro: any) => {
      this.centralPedidosErro = this.extractErrorText(erro, 'Não foi possível criar o cliente.');
    }).finally(() => {
      this.centralPedidosCriandoCliente = false;
    });
  }

  private filtreClientesPelaLojaDestino(clientes: any[]): any[] {
    if (!this.centralPedidosLojaManual) return clientes;
    const lojaDestinoId = this.centralPedidosLojaDestino?.id || this.centralPedidosLojaDestino?.empresaId;
    if (!lojaDestinoId) return clientes;
    return (clientes || []).filter((c: any) => {
      const idCliente = c?.lojaOrigem?.id || c?.empresaId;
      return String(idCliente || '') === String(lojaDestinoId);
    });
  }

  get centralPedidosLojasParaDialog(): any[] {
    if (!this.centralLojaManualCarregada() || !this.centralPedidosLojaDestino) {
      return this.centralPedidosLojasParticipantes;
    }
    return [this.centralPedidosLojaDestino];
  }

  private obtenhaLojaCentralPorId(id: any): any {
    if (!id) return null;
    return (this.centralPedidosLojasParticipantes || []).find((loja: any) => {
      const lojaId = loja?.id || loja?.empresaId;
      return String(lojaId || '') === String(id);
    }) || null;
  }

  private definaLojaAtendimentoCadastroCliente(id: any) {
    if (this.centralPedidosLojaDestino) return;

    const loja = this.obtenhaLojaCentralPorId(id);
    if (!loja) return;

    const lojaId = loja.id || loja.empresaId;
    this.centralPedidosLojaManual = true;
    this.centralPedidosLojaDestino = {
      ...loja,
      id: lojaId
    };
    this.centralPedidosRoteamento = {
      tipo: 'MANUAL',
      motivo: `Loja do atendimento selecionada ao cadastrar cliente: ${loja.nome}`
    };
    this.centralPedidosEntrega = null;
  }

  private prepareLojaAtendimentoAposCadastroCliente() {
    const loja = this.centralPedidosLojaDestino;
    if (!loja || !this.centralPedidosClienteSelecionado) return;
    if (!this.lojaCentralTemDelivery(loja)) {
      if (this.lojaCentralApenasRetirada(loja)) {
        this.prepareRetiradaCentralPedidos(loja, `Loja do atendimento selecionada ao cadastrar cliente: ${loja.nome}`);
      }
      return;
    }

    this.centralPedidosPreparando = true;
    this.prepareAtendimentoV3CentralPedidos(true);
  }

  abraDialogCentralPedidos() {
    if (!this.centralPedidosAtivo || !this.centralPedidosPodeOperar) return;
    this.centralPedidosLojasDialogAberto = false;
    this.abraDialogCentralPedidosComProtecao();
  }

  fecheDialogCentralPedidos() {
    if (this.centralPedidosPreparando) return;
    if (Date.now() < this.centralPedidosDialogFechamentoBloqueadoAte) return;
    this.centralPedidosDialogAberto = false;
    this.limpeDialogCentralPedidos();
  }

  private abraDialogCentralPedidosComProtecao() {
    this.centralPedidosDialogFechamentoBloqueadoAte = Date.now() + 350;
    this.centralPedidosDialogAberto = true;
  }

  private limpeDialogCentralPedidos() {
    const preservarClienteAtual = this.centralPedidosModoTrocaCliente || this.centralAtendimentoPreparado;
    this.clearCentralPedidosBuscaTimer();
    this.centralPedidosBuscaReqSeq++;
    this.centralPedidosBusca = '';
    this.centralPedidosBuscaUltimoTermo = '';
    this.centralPedidosBuscando = false;
    this.centralPedidosCriandoCliente = false;
    this.centralPedidosErro = '';
    this.centralPedidosClientes = [];
    this.centralPedidosClientesAgrupados = [];
    if (!preservarClienteAtual) {
      this.centralPedidosClienteSelecionado = null;
      this.centralPedidosEnderecos = [];
      this.centralPedidosEnderecoSelecionado = null;
    }
    this.centralPedidosModoTrocaCliente = false;

    if (!this.centralAtendimentoPreparado) {
      this.centralPedidosLojaManual = false;
      this.centralPedidosLojaDestino = null;
      this.centralPedidosRoteamento = null;
      this.centralPedidosEntrega = null;
    }
  }

  abraDialogLojasCentralPedidos() {
    if (!this.centralPedidosAtivo || !this.centralPedidosPodeOperar || this.centralPedidosPreparando) return;
    if (this.centralPedidosLojaDestino) return;
    this.centralPedidosDialogAberto = false;
    this.centralPedidosLojasDialogAberto = true;
  }

  fecheDialogLojasCentralPedidos() {
    if (this.centralPedidosPreparando) return;
    this.centralPedidosLojasDialogAberto = false;
  }

  atualizeBuscaCentralPedidos(termo: string) {
    this.centralPedidosBusca = termo;
    this.agendeBuscaClientesCentralPedidos();
  }

  troqueClienteCentralPedidos(): boolean {
    if (this.centralPedidosPreparando) return false;

    this.centralPedidosModoTrocaCliente = true;
    this.centralPedidosBusca = '';
    this.centralPedidosBuscaUltimoTermo = '';
    this.centralPedidosClientes = [];
    this.centralPedidosClientesAgrupados = [];
    this.centralPedidosErro = '';
    return true;
  }

  selecioneEnderecoCentralPedidos(endereco: any) {
    const cliente = this.centralPedidosClienteSelecionado;
    if (!cliente || !endereco) return;

    const enderecoAtualId = this.centralPedidosEnderecoSelecionado?.enderecoId || this.centralPedidosEnderecoSelecionado?.id;
    const enderecoNovoId = endereco?.enderecoId || endereco?.id;
    const trocouEndereco = !!enderecoAtualId && String(enderecoAtualId) !== String(enderecoNovoId);
    const preservaCarrinhoEndereco = this.centralLojaManualCarregada();
    if (trocouEndereco && !preservaCarrinhoEndereco && !this.confirmeDescartoCarrinho('endereco')) return;

    this.centralPedidosEnderecoSelecionado = endereco;
    if (!this.centralLojaManualCarregada()) {
      this.limpeAtendimentoCentralResolvido(false, true);
    }
    this.centralPedidosErro = '';
    this.centralPedidosPreparando = true;

    this.grupolojasService.selecioneEnderecoCentralPedidos(
      cliente.empresaId,
      cliente.contatoId,
      endereco.enderecoId || endereco.id,
      this.centralPedidosGrupoDeLojasId
    ).then((resposta: any) => {
      this.centralPedidosEnderecoSelecionado = resposta?.endereco || endereco;
      if (this.centralPedidosLojaManual && this.centralPedidosLojaDestino) {
        this.prepareAtendimentoV3CentralPedidos();
      } else {
        this.resolvaLojaCentralPedidos();
      }
    }).catch((erro: any) => {
      this.centralPedidosPreparando = false;
      this.centralPedidosErro = this.extractErrorText(erro, 'Não foi possível selecionar o endereço.');
    });
  }

  cadastreEnderecoCentralPedidos(loja?: any) {
    const cliente = this.centralPedidosClienteSelecionado;
    if (!cliente?.contatoId || this.centralPedidosPreparando) return;
    if (!loja && !this.centralPedidosLojaDestino) return;

    if (loja) {
      const lojaId = loja.id || loja.empresaId;
      const lojaAtualId = this.centralPedidosLojaDestino?.id || this.centralPedidosLojaDestino?.empresaId;
      const mudouLoja = !!lojaAtualId && String(lojaAtualId) !== String(lojaId);
      if (mudouLoja && !this.confirmeDescartoCarrinho('loja')) return;
      this.centralPedidosLojaManual = true;
      this.centralPedidosLojaDestino = {
        ...loja,
        id: loja.id || loja.empresaId
      };
      this.centralPedidosRoteamento = {
        tipo: 'MANUAL',
        motivo: `Loja selecionada para delivery na Central: ${loja.nome}`
      };
    }

    this.centralPedidosErro = '';
    this.centralPedidosPreparando = true;
    this.prepareAtendimentoV3CentralPedidos(true);
  }

  continueRetiradaDestinoCentralPedidos() {
    const cliente = this.centralPedidosClienteSelecionado;
    const loja = this.centralPedidosLojaDestino;
    if (!cliente?.contatoId || !loja || this.centralPedidosPreparando) return;
    this.prepareRetiradaCentralPedidos(loja, `Loja selecionada para retirada na Central: ${loja.nome || ''}`);
  }

  resolvaLojaCentralPedidos() {
    const cliente = this.centralPedidosClienteSelecionado;
    const endereco = this.centralPedidosEnderecoSelecionado;
    if (!cliente || !endereco) return;

    this.centralPedidosPreparando = true;
    this.centralPedidosErro = '';

    this.grupolojasService.roteieLojaCentralPedidos(
      cliente.empresaId,
      cliente.contatoId,
      endereco.enderecoId || endereco.id,
      this.centralPedidosGrupoDeLojasId
    ).then((resposta: any) => {
      if (!resposta?.resolvido) {
        const lojaOrigem = this.obtenhaLojaOrigemClienteCentral(cliente);
        if (lojaOrigem) {
          this.centralPedidosLojaManual = true;
          this.centralPedidosLojaDestino = lojaOrigem;
          this.centralPedidosRoteamento = {
            tipo: 'MANUAL',
            motivo: `Loja do cadastro do cliente: ${lojaOrigem.nome}`
          };
          this.centralPedidosEntrega = null;
          this.prepareAtendimentoV3CentralPedidos();
          return;
        }

        this.centralPedidosErro = resposta?.mensagem || 'Nenhuma loja atende este endereço.';
        this.centralPedidosPreparando = false;
        return;
      }

      this.centralPedidosLojaManual = false;
      this.centralPedidosLojaDestino = resposta.loja;
      this.centralPedidosRoteamento = resposta.roteamento;
      this.centralPedidosEntrega = resposta.entrega;
      this.prepareAtendimentoV3CentralPedidos();
    }).catch((erro: any) => {
      this.centralPedidosPreparando = false;
      this.centralPedidosErro = this.extractErrorText(erro, 'Não foi possível resolver a loja destino.');
    });
  }

  private obtenhaLojaOrigemClienteCentral(cliente: any): any {
    const lojaOrigemId = cliente?.lojaOrigem?.id || cliente?.empresaId;
    if (!lojaOrigemId) return null;

    const loja = this.centralPedidosLojasParticipantes.find((item: any) => {
      const lojaId = item?.id || item?.empresaId;
      return item?.ativa && String(lojaId || '') === String(lojaOrigemId);
    });

    return loja ? { ...loja, id: loja.id || loja.empresaId } : null;
  }

  private obtenhaLojaRetiradaClienteCentral(cliente: any): any {
    if (this.centralPedidosLojaManual && this.lojaCentralPermiteRetirada(this.centralPedidosLojaDestino)) {
      return this.centralPedidosLojaDestino;
    }

    const lojaOrigem = this.obtenhaLojaOrigemClienteCentral(cliente);
    return this.lojaCentralPermiteRetirada(lojaOrigem) ? lojaOrigem : null;
  }

  private lojaCentralApenasRetirada(loja: any): boolean {
    if (!loja) return false;
    if (loja.retiradaAtiva === undefined && loja.deliveryAtivo === undefined) return true;
    return this.valorCentralBooleano(loja?.retiradaAtiva) && !this.valorCentralBooleano(loja?.deliveryAtivo);
  }

  private lojaCentralPermiteRetirada(loja: any): boolean {
    if (!loja) return false;
    if (loja.retiradaAtiva === undefined && loja.deliveryAtivo === undefined) return true;
    return this.valorCentralBooleano(loja?.retiradaAtiva);
  }

  private valorCentralBooleano(valor: any): boolean {
    return valor === true || valor === 1 || valor === '1';
  }

  private prepareRetiradaCentralPedidos(loja: any, motivo: string) {
    this.centralPedidosLojaManual = true;
    this.centralPedidosLojaDestino = {
      ...loja,
      id: loja.id || loja.empresaId
    };
    this.centralPedidosRoteamento = {
      tipo: 'RETIRADA',
      motivo
    };
    this.centralPedidosEntrega = null;
    this.centralPedidosEnderecoSelecionado = null;
    this.centralPedidosErro = '';
    this.centralPedidosPreparando = true;
    this.prepareAtendimentoV3CentralPedidos();
  }

  prepareAtendimentoV3CentralPedidos(enderecoPendente: boolean = false) {
    const cliente = this.centralPedidosClienteSelecionado;
    const endereco = this.centralPedidosEnderecoSelecionado;
    const loja = this.centralPedidosLojaDestino;
    const pedidoRetirada = this.centralPedidosRoteamento?.tipo === 'RETIRADA' || this.lojaCentralApenasRetirada(loja);
    if (!cliente || !loja || (!pedidoRetirada && !endereco && !enderecoPendente)) return;

    const dados = {
      empresaDestinoId: loja.id,
      empresaOrigemId: cliente.empresaId,
      contatoId: cliente.contatoId,
      enderecoId: endereco ? (endereco.enderecoId || endereco.id) : null,
      tipoPedido: pedidoRetirada ? 'RETIRADA' : 'DELIVERY',
      lojaManual: this.centralPedidosLojaManual,
      enderecoPendente,
      tipoRoteamento: pedidoRetirada ? 'RETIRADA' : (this.centralPedidosLojaManual ? 'MANUAL' : 'REGRAS_LOJA'),
      motivoRoteamento: this.centralPedidosRoteamento?.motivo || null
    };

    this.grupolojasService.prepareAtendimentoV3CentralPedidos(dados, this.centralPedidosGrupoDeLojasId).then((resposta: any) => {
      this.apliqueAtendimentoCentralPreparado(resposta || {});
    }).catch((erro: any) => {
      this.centralPedidosErro = this.extractErrorText(erro, 'Não foi possível preparar o atendimento na loja destino.');
    }).finally(() => {
      this.centralPedidosPreparando = false;
    });
  }

  private prepareLojaManualV3CentralPedidos(loja: any) {
    if (!loja?.id) return;

    this.centralPedidosPreparando = true;
    this.centralPedidosErro = '';
    this.grupolojasService.prepareLojaV3CentralPedidos({
      empresaDestinoId: loja.id,
      motivoRoteamento: this.centralPedidosRoteamento?.motivo || `Loja selecionada manualmente na Central: ${loja.nome}`
    }, this.centralPedidosGrupoDeLojasId).then((resposta: any) => {
      this.apliqueLojaCentralPreparada(resposta || {});
    }).catch((erro: any) => {
      this.centralPedidosErro = this.extractErrorText(erro, 'Não foi possível carregar a loja selecionada.');
    }).finally(() => {
      this.centralPedidosPreparando = false;
    });
  }

  private apliqueLojaCentralPreparada(resposta: any) {
    this.centralAtendimentoPreparado = true;
    this.centralPedidosDialogAberto = false;
    this.centralPedidosLojasDialogAberto = false;
    const lojaPreparada = resposta.lojaDestino || resposta.loja || {};
    this.centralPedidosLojaDestino = {
      ...this.centralPedidosLojaDestino,
      ...lojaPreparada
    };
    this.centralPedidosRoteamento = resposta.roteamento || this.centralPedidosRoteamento;
    this.centralPedidosEntrega = null;
    this.deliveryFee = '';
    this.deliveryFeeError = '';
    this.deliveryFeeLoading = false;
    this.payAddressRequirementTouched = false;
    this.orderType = 'delivery';
    this.subType = this.lojaCentralApenasRetirada(this.centralPedidosLojaDestino) ? 'retirada' : 'entrega';

    this.constantsService.recarregueEmpresa((empresa: any) => {
      if (empresa?.id) {
        this.empresa = empresa;
      }
      this.selectModule(this.subType === 'retirada' ? 'retirada' : 'delivery');
    });
  }

  private apliqueAtendimentoCentralPreparado(resposta: any) {
    this.centralAtendimentoPreparado = true;
    this.centralPedidosDialogAberto = false;
    this.centralPedidosLojasDialogAberto = false;
    this.centralPedidosLojaDestino = resposta.lojaDestino || this.centralPedidosLojaDestino;
    this.centralPedidosRoteamento = resposta.roteamento || this.centralPedidosRoteamento;
    this.centralPedidosEntrega = resposta.entrega || this.centralPedidosEntrega;

    const clienteDestino = resposta.clienteDestino || {};
    const enderecoDestino = resposta.enderecoDestino || null;
    this.selectedContact = {
      ...clienteDestino,
      id: clienteDestino.id || clienteDestino.contatoId,
      enderecos: enderecoDestino ? [enderecoDestino] : []
    };
    this.selectedAddress = enderecoDestino ? this.normalizeAddressForLegacyApi({
      ...enderecoDestino,
      id: enderecoDestino.id || enderecoDestino.enderecoId
    }) : null;
    this.customerName = this.selectedContact.nome || '';
    this.customerPhone = (this.selectedContact.codigoPais || '+55') + (this.selectedContact.telefone || '');
    this.customerAddress = this.selectedAddress ? this.getClientAddressFull(this.selectedAddress) : '';
    const taxa = resposta.entrega?.taxa ?? this.centralPedidosEntrega?.taxa;
    this.deliveryFee = taxa === null || taxa === undefined ? '' : String(taxa);
    this.deliveryFeeError = '';
    this.deliveryFeeLoading = false;
    this.payAddressRequirementTouched = false;
    this.orderType = 'delivery';
    this.subType = resposta.centralContexto?.tipoPedido === 'RETIRADA' ? 'retirada' : 'entrega';

    this.constantsService.recarregueEmpresa((empresa: any) => {
      if (empresa?.id) {
        this.empresa = empresa;
      }
      this.selectModule(this.subType === 'retirada' ? 'retirada' : 'delivery');
    });
  }

  selecioneLojaManualCentralPedidos(loja: any) {
    if (!this.centralPedidosAtivo || !this.centralPedidosPodeOperar || !loja || !loja.ativa || this.centralPedidosPreparando) return;

    const lojaId = loja.id || loja.empresaId;
    const lojaAtualId = this.centralPedidosLojaDestino?.id || this.centralPedidosLojaDestino?.empresaId;
    if (lojaAtualId && String(lojaAtualId) !== String(lojaId)) return;
    const mudouLoja = !!lojaAtualId && String(lojaAtualId) !== String(lojaId);
    this.centralPedidosLojasDialogAberto = false;
    this.centralPedidosLojaManual = true;
    this.centralPedidosLojaDestino = {
      ...loja,
      id: lojaId
    };
    this.centralPedidosRoteamento = {
      tipo: 'MANUAL',
      motivo: `Loja selecionada manualmente na Central: ${loja.nome}`
    };
    this.centralPedidosEntrega = null;
    this.centralPedidosErro = '';
    if (mudouLoja) {
      this.limpeAtendimentoCentralResolvido(false, true);
      this.payScreen = false;
    }

    if (this.centralPedidosClienteSelecionado && (!this.centralPedidosEnderecoSelecionado || this.lojaCentralApenasRetirada(this.centralPedidosLojaDestino)) && this.lojaCentralPermiteRetirada(this.centralPedidosLojaDestino)) {
      this.prepareRetiradaCentralPedidos(this.centralPedidosLojaDestino, `Loja selecionada para retirada na Central: ${loja.nome}`);
      return;
    }

    if (this.centralPedidosClienteSelecionado && this.centralPedidosEnderecoSelecionado) {
      this.centralPedidosPreparando = true;
      this.prepareAtendimentoV3CentralPedidos();
      return;
    }

    if (this.centralPedidosClienteSelecionado) {
      this.centralPedidosPreparando = true;
      this.prepareAtendimentoV3CentralPedidos(true);
      return;
    }

    this.prepareLojaManualV3CentralPedidos(this.centralPedidosLojaDestino);
  }

  private limpeAtendimentoCentralResolvido(limparEndereco: boolean = true, preservarLojaManual: boolean = false) {
    const devePreservarLojaManual = preservarLojaManual && this.centralPedidosLojaManual && !!this.centralPedidosLojaDestino;

    if (limparEndereco) {
      this.centralPedidosEnderecoSelecionado = null;
    }

    if (!devePreservarLojaManual) {
      this.centralPedidosLojaManual = false;
      this.centralPedidosLojaDestino = null;
      this.centralPedidosRoteamento = null;
    }
    this.centralPedidosEntrega = null;
    this.centralPedidosPreparando = false;
    this.centralAtendimentoPreparado = false;
    this.cart = [];
    this.selectedContact = null;
    this.selectedAddress = null;
    this.customerName = '';
    this.customerPhone = '';
    this.customerAddress = '';
    this.deliveryFee = '';
    this.categorias = [];
    this.produtos = [];
    this._cachedCategoryList = [{nome: 'Todos', count: 0, cor: '#6366f1', fundo: '#eef2ff'}];
    this.payMethods = [];
    this.availablePayMethods = [];
    this.refreshPayMethodSections();
  }

  private agrupeClientesCentral(clientes: any[]) {
    const grupos: any[] = [];
    const mapa: any = {};

    (clientes || []).forEach((cliente: any) => {
      const loja = cliente.lojaOrigem || {id: cliente.empresaId, nome: cliente.empresaNome};
      const chave = String(loja.id || cliente.empresaId || 'sem-loja');
      if (!mapa[chave]) {
        mapa[chave] = {
          loja,
          clientes: []
        };
        grupos.push(mapa[chave]);
      }
      mapa[chave].clientes.push(cliente);
    });

    return grupos;
  }

  // ==========================================
  // SELEÇÃO DE CLIENTE
  // ==========================================
  openClientModal() {
    if (this.centralPedidosAtivo) {
      if (this.selectedContact || this.centralPedidosClienteSelecionado) {
        if (this.troqueClienteCentralPedidos()) {
          this.abraDialogCentralPedidos();
        }
        return;
      }
      this.abraDialogCentralPedidos();
      return;
    }
    if (this.isBalcaoMode) return;
    this.clearClientSearchTimer();
    this.clientSearchReqSeq++;
    this.showClientModal = true;
    this.clientModalAddressOnly = false;
    this.clientSearch = '';
    this.clientResults = [];
    this.clientSearchLoading = false;
    this.clientSearchError = false;
    this.clientSearchLastTerm = '';
    this.expandedClientId = null;
  }

  abraTrocaClientePedido(event?: Event) {
    event?.stopPropagation();
    if (this.centralPedidosAtivo) {
      if (this.troqueClienteCentralPedidos()) {
        this.abraDialogCentralPedidos();
      }
      return;
    }
    this.openClientModal();
  }

  closeClientModal() {
    this.clearClientSearchTimer();
    this.clientSearchReqSeq++;
    this.clientSearchLoading = false;
    this.clientModalAddressOnly = false;
    this.showClientModal = false;
  }

  openSelectedClientAddressModal(event?: Event) {
    event?.stopPropagation();
    if (this.centralPedidosAtivo && !this.centralAtendimentoPreparado) return;
    if (!this.selectedContact?.id) {
      this.openClientModal();
      return;
    }

    this.clearClientSearchTimer();
    this.clientSearchReqSeq++;
    this.showClientModal = true;
    this.clientModalAddressOnly = true;
    this.clientSearch = '';
    this.clientSearchLoading = false;
    this.clientSearchError = false;
    this.clientSearchLastTerm = '';

    const fixedClient: any = {
      ...this.selectedContact,
      _loadingDetails: false,
      _loadError: false
    };

    if (Array.isArray(this.selectedContact?.enderecos)) {
      fixedClient.enderecos = this.normalizeClientAddresses(this.selectedContact.enderecos);
      fixedClient._loaded = true;
    } else {
      fixedClient.enderecos = [];
      fixedClient._loaded = false;
    }

    this.clientResults = [fixedClient];
    this.expandedClientId = fixedClient.id;

    this.loadClientDetails(fixedClient, !fixedClient._loaded);
  }

  searchClients(term: string = this.clientSearch) {
    this.clearClientSearchTimer();
    this.clientSearch = term || '';
    const normalizedTerm = this.clientSearch.trim();
    const reqId = ++this.clientSearchReqSeq;

    if (!normalizedTerm || normalizedTerm.length < 2) {
      this.clientResults = [];
      this.clientSearchLoading = false;
      this.clientSearchError = false;
      this.clientSearchLastTerm = '';
      this.expandedClientId = null;
      return;
    }

    this.clientSearchTimer = setTimeout(() => {
      this.clientSearchTimer = null;
      this.runClientSearch(normalizedTerm, reqId);
    }, 300);
  }

  toggleClientExpand(client: any) {
    this.expandedClientId = this.expandedClientId === client.id ? null : client.id;
    if (this.expandedClientId === client.id) {
      this.loadClientDetails(client);
    }
  }

  retryClientDetails(client: any, event?: Event) {
    event?.stopPropagation();
    this.loadClientDetails(client, true);
  }

  openCreateClientAddressModal(client: any, event?: Event) {
    event?.stopPropagation();
    if (!client?.id) return;

    const windowRef: DialogRef = this.dialogService.open({
      title: null,
      content: CadEnderecoContatoComponent,
      minWidth: 260,
      width: window.innerWidth > 680 ? 600 : Math.max(320, window.innerWidth - 24),
      maxHeight: window.innerHeight - 80,
      cssClass: 'bsModal'
    });

    KendoPopupUtils.abriuPopupNgBootstrap(windowRef);

    const enderecoBase = {
      contato: {id: client.id},
      cidade: client?.enderecos?.[0]?.cidade || this.empresa?.enderecoCompleto?.cidade || null
    };

    windowRef.content.instance.setEndereco(enderecoBase, true);

    windowRef.result.subscribe((result: any) => {
      if (!result || !result.id) return;

      const targetClient =
        this.clientResults.find((c: any) => String(c?.id) === String(client.id)) || client;

      this.expandedClientId = targetClient.id;
      this.loadClientDetails(targetClient, true);
    });
  }

  openCreateClientModal(event?: Event) {
    event?.stopPropagation();
    if (this.clientModalAddressOnly) return;

    const windowRef: DialogRef = this.dialogService.open({
      title: null,
      content: NovoContatoComponent,
      minWidth: 260,
      width: window.innerWidth > 680 ? 600 : Math.max(320, window.innerWidth - 24),
      maxHeight: window.innerHeight - 80,
      cssClass: 'bsModal'
    });

    KendoPopupUtils.abriuPopupNgBootstrap(windowRef);

    const contatoBase = this.buildContactPrefillFromSearch();
    if (windowRef.content?.instance?.exibaContato) {
      windowRef.content.instance.exibaContato(contatoBase);
    }

    windowRef.result.subscribe((result: any) => {
      if (!result) return;
      this.handleCreatedClient(result);
    }, () => {});
  }

  selectClient(client: any, address?: any) {
    this.selectedContact = client;
    this.selectedAddress = address ? this.normalizeAddressForLegacyApi(address) : null;
    this.customerName = client.nome;
    this.customerPhone = (client.codigoPais || '') + (client.telefone || '');
    this.deliveryFee = '';
    this.deliveryFeeLoading = false;
    this.deliveryFeeError = '';
    this.customerAddress = '';
    if (address) {
      this.payAddressRequirementTouched = false;
      const extractedFee = this.extractAddressFee(address);
      this.deliveryFee = extractedFee === null ? '' : String(extractedFee);
      this.customerAddress = this.getClientAddressFull(address);
      if (this.orderType !== 'mesa' && this.subType !== 'entrega') {
        this.setSubType('entrega');
      } else if (this.isDeliveryMode) {
        this.recalculateDeliveryFee('address', {force: true});
      }
    }
    this.initLoyaltyForSelectedContact();
    this.syncPayMethodsWithCurrentTotal();
    this.closeClientModal();
  }

  clearClient() {
    this.selectedContact = null;
    this.selectedAddress = null;
    this.payLater = false;
    this.customerName = '';
    if (!this.isBalcaoMode)
      this.identificacaoBalcao = '';

    this.customerPhone = '';
    this.clearDeliveryFeeCalcTimer();
    this.deliveryFeeReqSeq++;
    this.deliveryFeeLoading = false;
    this.deliveryFeeError = '';
    this.deliveryFeeLastCalcKey = '';
    this.deliveryFee = '';
    this.customerAddress = '';
    this.resetLoyaltyStates();
    this.syncPayMethodsWithCurrentTotal();
  }

  selectNoClient() {
    this.clearClient();
    this.closeClientModal();
  }

  onIdentificacaoBalcaoChange() {
    this.identificacaoBalcao = (this.identificacaoBalcao || '').trim();
  }

  selectClientWithoutAddress(client: any, event?: Event) {
    event?.stopPropagation();
    const shouldSwitchToRetirada = this.orderType !== 'mesa' && this.subType === 'entrega';
    this.selectClient(client);
    if (shouldSwitchToRetirada) {
      this.setSubType('retirada');
    }
  }

  get isDeliveryMode(): boolean {
    return this.orderType !== 'mesa' && this.subType === 'entrega';
  }

  setSubType(type: 'retirada' | 'entrega') {
    if (this.centralPedidosAtivo && !this.centralAtendimentoPreparado && type !== 'entrega') {
      this.subType = 'entrega';
      return;
    }

    this.subType = type;
    this.payAddressRequirementTouched = false;
    this.loadPaymentMethods();
    this.syncAgendamentoObrigatorio();
    if (type === 'retirada') {
      this.clearDeliveryFeeCalcTimer();
      this.deliveryFeeReqSeq++;
      this.deliveryFeeLoading = false;
      this.deliveryFeeError = '';
      this.deliveryFeeLastCalcKey = '';
      this.selectedAddress = null;
      this.customerAddress = '';
      this.deliveryFee = '';
      this.syncPayMethodsWithCurrentTotal();
      return;
    }
    if (!this.selectedAddress) {
      this.deliveryFeeLoading = false;
      this.deliveryFeeError = '';
      this.deliveryFeeLastCalcKey = '';
      this.deliveryFee = '';
      this.syncPayMethodsWithCurrentTotal();
      if (this.selectedContact?.id) {
        this.openSelectedClientAddressModal();
      } else {
        this.openClientModal();
      }
      return;
    }
    this.recalculateDeliveryFee('subtype', {force: true});
  }

  getClientInitial(client: any): string {
    return (client.nome || '?').charAt(0).toUpperCase();
  }

  getClientStatusLabel(client: any): string {
    const normalized = this.normalizeText(client?.status);
    if (!normalized) return '';
    const activeStatuses = new Set(['confirmado', 'ativo', 'active', '1', 'true']);
    return activeStatuses.has(normalized) ? 'Ativo' : 'Pendente';
  }

  isClientStatusActive(client: any): boolean {
    return this.getClientStatusLabel(client) === 'Ativo';
  }

  canExpandClientAddresses(client: any): boolean {
    if (!client) return false;
    if (client._loadingDetails || client._loadError) return true;
    if (!client._loaded) return true;
    return this.getClientAddressCount(client) > 0;
  }

  getClientAddressCount(client: any): number {
    return Array.isArray(client?.enderecos) ? client.enderecos.length : 0;
  }

  getClientAddressPrimary(addr: any): string {
    if (!addr) return 'Endereço não informado';
    const street = (addr.logradouro || addr.endereco || '').toString().trim();
    const number = (addr.numero || '').toString().trim();
    const complemento = (addr.complemento || '').toString().trim();
    const base = [street || 'Endereço', number || 's/n'].filter(Boolean).join(', ');
    return complemento ? `${base} • ${complemento}` : base;
  }

  getClientAddressSecondary(addr: any): string {
    if (!addr) return '';
    const bairro = (addr.bairro || '').toString().trim();
    const cidade = (addr.cidade?.nome || addr.cidade || '').toString().trim();
    const uf = (addr.estado?.sigla || addr.uf || '').toString().trim();
    const localidade = (!cidade && !uf ? (addr.localidade || '').toString().trim() : '');
    const cep = (addr.cep || '').toString().trim();
    const cityUf = [cidade, uf].filter(Boolean).join('/');
    return [bairro, cityUf || localidade, cep].filter(Boolean).join(' • ');
  }

  getClientAddressFull(addr: any): string {
    if (!addr) return '';
    const desc = (addr.descricao || '').toString().trim();
    const ref = (addr.pontoDeReferencia || '').toString().trim();
    const primary = this.getClientAddressPrimary(addr);
    const secondary = this.getClientAddressSecondary(addr);
    const head = desc ? `${desc}: ${primary}` : primary;
    const parts = [head, secondary];
    if (ref) parts.push(`Ref.: ${ref}`);
    return parts.filter(Boolean).join(' • ');
  }

  hasClientAddressFee(addr: any): boolean {
    return this.getClientAddressFeeValue(addr) > 0;
  }

  getClientAddressFeeValue(addr: any): number {
    return this.extractAddressFee(addr) ?? 0;
  }

  canSelectClientWithoutAddress(): boolean {
    return true;
  }

  private loadClientDetails(client: any, force = false) {
    if (!client?.id) return Promise.resolve();
    if (client._loadingDetails) return Promise.resolve();
    if (!force && client._loaded) return Promise.resolve();

    client._loadingDetails = true;
    client._loadError = false;

    const contatoPromise = this.contatosService.obtenhaContatoPorId(client.id)
      .then((full: any) => ({ok: true, data: full}))
      .catch(() => ({ok: false, data: null}));

    const enderecosPromise = this.enderecoService.obtenhaEnderecos({id: client.id})
      .then((enderecos: any) => ({ok: true, data: enderecos}))
      .catch(() => ({ok: false, data: null}));

    return Promise.all([contatoPromise, enderecosPromise]).then(([contatoResp, enderecosResp]: any[]) => {
      const full = contatoResp?.ok ? contatoResp.data : null;

      if (full) {
        client.nome = full.nome || client.nome;
        client.status = full.status || client.status;
        client.codigoPais = full.codigoPais || client.codigoPais;
        client.telefone = full.telefone || client.telefone;
        if (Array.isArray(full.cartoes)) {
          client.cartoes = full.cartoes;
        }
        client._fullDetails = full;
      }

      const enderecosFonte = Array.isArray(enderecosResp?.data)
        ? enderecosResp.data
        : (Array.isArray(full?.enderecos) ? full.enderecos : []);

      client.enderecos = this.normalizeClientAddresses(enderecosFonte);
      client._loaded = !!full || !!enderecosResp?.ok;
      client._loadError = !client._loaded;
      if (this.selectedContact && String(this.selectedContact.id) === String(client.id)) {
        this.selectedContact = client;
        this.initLoyaltyForSelectedContact();
      }
    }).catch(() => {
      client._loadError = true;
      if (!Array.isArray(client.enderecos)) client.enderecos = [];
      client._loaded = false;
    }).finally(() => {
      client._loadingDetails = false;
    });
  }

  private normalizeClientAddresses(addresses: any[]): any[] {
    if (!Array.isArray(addresses)) return [];
    return addresses
      .filter((addr: any) => !!addr)
      .map((addr: any) => this.normalizeAddressForLegacyApi(addr));
  }

  private normalizeAddressForLegacyApi(addr: any): any {
    if (!addr || typeof addr !== 'object') return addr;

    const normalized = {...addr};
    const zona = normalized.zonaDeEntrega || normalized.zonaEntrega || null;

    if (zona) {
      normalized.zonaDeEntrega = zona;
      normalized.zonaEntrega = zona;
    }

    return normalized;
  }

  private buildContactPrefillFromSearch(): any {
    const rawSearch = (this.clientSearch || '').trim();
    const digits = rawSearch.replace(/\D+/g, '');
    const contatoBase: any = {};

    if (!rawSearch && this.centralPedidosAtivo && this.centralAtendimentoPreparado && this.selectedContact && !this.selectedContact.id) {
      return {
        nome: this.selectedContact.nome || this.customerName || 'Cliente',
        telefone: this.selectedContact.telefone || '',
        codigoPais: this.selectedContact.codigoPais || '+55',
        email: this.selectedContact.email || null
      };
    }

    if (!rawSearch) {
      return contatoBase;
    }

    if (digits.length >= 3 && !/[a-zA-Z]/.test(rawSearch)) {
      const parsed = rawSearch.startsWith('+')
        ? this.contatosService.extraiCodigoPaisETelefone(rawSearch)
        : null;

      contatoBase.telefone = parsed?.telefone || digits;
      contatoBase.codigoPais = parsed?.codigoPais || '+55';
      return contatoBase;
    }

    contatoBase.nome = rawSearch;
    return contatoBase;
  }

  private handleCreatedClient(createdClient: any) {
    if (!createdClient) return;

    const finishSelection = (client: any) => {
      if (!client) return;
      this.selectClient(client);
      if (this.isDeliveryMode) {
        setTimeout(() => this.openSelectedClientAddressModal(), 0);
      }
    };

    if (!createdClient.id) {
      finishSelection(createdClient);
      return;
    }

    this.contatosService.obtenhaContatoPorId(String(createdClient.id)).then((contatoCompleto: any) => {
      finishSelection(contatoCompleto || createdClient);
    }).catch(() => {
      finishSelection(createdClient);
    });
  }

  private scheduleDeliveryFeeRecalcFromCart() {
    if (!this.isDeliveryMode || !this.selectedAddress) return;
    this.clearDeliveryFeeCalcTimer();
    this.deliveryFeeCalcTimer = setTimeout(() => {
      this.deliveryFeeCalcTimer = null;
      this.recalculateDeliveryFee('cart');
    }, 150);
  }

  private clearDeliveryFeeCalcTimer() {
    if (this.deliveryFeeCalcTimer) {
      clearTimeout(this.deliveryFeeCalcTimer);
      this.deliveryFeeCalcTimer = null;
    }
  }

  private getDeliveryFeeCalcKey(): string {
    const addr = this.selectedAddress || {};
    const addrId = (addr.id ?? '').toString();
    const zonaId = (addr.zonaDeEntrega?.id ?? addr.zonaEntrega?.id ?? '').toString();
    const taxaCalcId = (addr.taxaCalculadaId ?? '').toString();
    const subtotal = this.cartSubtotal.toFixed(2);
    return [this.subType, subtotal, addrId, zonaId, taxaCalcId].join('|');
  }

  private normalizeDeliveryFeeResponse(resposta: any): {ok: boolean; dados: any; erro?: string} {
    if (resposta && typeof resposta === 'object' && Object.prototype.hasOwnProperty.call(resposta, 'sucesso')) {
      if (resposta.sucesso) {
        return {ok: true, dados: resposta.data || {}};
      }
      return {ok: false, dados: null, erro: (resposta.erro || 'Erro ao calcular taxa de entrega').toString()};
    }
    return {ok: true, dados: resposta || {}};
  }

  private applyCalculatedDeliveryFeeData(dados: any) {
    if (!this.selectedAddress || !dados || typeof dados !== 'object') return;
    Object.assign(this.selectedAddress, dados);
    if (dados.localizacao) {
      this.selectedAddress.localizacao = dados.localizacao;
    }
  }

  private extractCalculatedFeeFromResponseData(dados: any): number | null {
    if (!dados) return null;
    const candidates = [
      dados?.taxaDeEntrega,
      dados?.taxaEntrega,
      dados?.taxa,
      dados?.valor
    ];
    for (const candidate of candidates) {
      if (candidate === null || candidate === undefined || candidate === '') continue;
      const fee = Number(candidate);
      if (Number.isFinite(fee)) return fee;
    }
    return null;
  }

  private recalculateDeliveryFee(reason: 'address' | 'cart' | 'subtype', opts: {force?: boolean} = {}) {
    if (!this.isDeliveryMode || !this.selectedAddress) {
      this.deliveryFeeLoading = false;
      return;
    }

    const calcKey = this.getDeliveryFeeCalcKey();
    if (!opts.force && calcKey === this.deliveryFeeLastCalcKey) {
      return;
    }

    const reqId = ++this.deliveryFeeReqSeq;
    this.deliveryFeeLoading = true;
    this.deliveryFeeError = '';

    const subtotal = Math.max(0, this.cartSubtotal);
    const enderecoParaCalculo = this.normalizeAddressForLegacyApi(this.selectedAddress);
    this.enderecoService.calculeTaxaDeEntrega('Receber em casa', enderecoParaCalculo, subtotal).toPromise()
      .then((resposta: any) => {
        if (reqId !== this.deliveryFeeReqSeq || !this.isDeliveryMode || !this.selectedAddress) return;

        const parsed = this.normalizeDeliveryFeeResponse(resposta);
        if (!parsed.ok) {
          throw new Error(parsed.erro || 'Erro ao calcular taxa de entrega');
        }

        this.applyCalculatedDeliveryFeeData(parsed.dados);

        const fee = this.extractCalculatedFeeFromResponseData(parsed.dados);
        if (fee !== null && fee >= 0) {
          this.deliveryFee = String(fee);
        } else {
          const fallbackFee = this.extractAddressFee(this.selectedAddress);
          this.deliveryFee = fallbackFee === null ? '' : String(fallbackFee);
        }

        this.deliveryFeeLastCalcKey = calcKey;
        this.syncPayMethodsWithCurrentTotal();
      })
      .catch((err: any) => {
        if (reqId !== this.deliveryFeeReqSeq || !this.isDeliveryMode) return;
        const fallbackFee = this.extractAddressFee(this.selectedAddress);
        if ((this.deliveryFee === '' || this.deliveryFee === null || this.deliveryFee === undefined) && fallbackFee !== null) {
          this.deliveryFee = String(fallbackFee);
        }
        this.deliveryFeeError = typeof err === 'string' ? err : (err?.message || 'Nao foi possivel calcular automaticamente');
        this.syncPayMethodsWithCurrentTotal();
      })
      .finally(() => {
        if (reqId !== this.deliveryFeeReqSeq) return;
        this.deliveryFeeLoading = false;
      });
  }

  private extractAddressFee(addr: any): number | null {
    const candidates = [
      addr?.taxaDeEntrega,
      addr?.taxaEntrega,
      addr?.taxa,
      addr?.valor,
      addr?.zonaDeEntrega?.valor,
      addr?.zonaEntrega?.valor,
      addr?.zona_de_entrega_valor
    ];

    for (const candidate of candidates) {
      if (candidate === null || candidate === undefined || candidate === '') continue;
      const fee = Number(candidate);
      if (Number.isFinite(fee)) return fee;
    }

    return null;
  }

  private runClientSearch(term: string, reqId: number = ++this.clientSearchReqSeq) {
    const normalizedTerm = (term || '').trim();

    if (normalizedTerm.length < 2) {
      this.clientResults = [];
      this.clientSearchLoading = false;
      this.clientSearchError = false;
      this.clientSearchLastTerm = '';
      this.expandedClientId = null;
      return;
    }

    if (!this.clientSearchError && normalizedTerm === this.clientSearchLastTerm && this.clientResults.length > 0) {
      return;
    }

    this.clientSearchLoading = true;
    this.clientSearchError = false;

    this.contatosService.obtenhaContatosAC(normalizedTerm).then((results: any) => {
      if (reqId !== this.clientSearchReqSeq || !this.showClientModal) return;

      this.clientResults = (results || []).map((client: any) => ({
        ...client,
        _loaded: Array.isArray(client?.enderecos),
        _loadingDetails: false,
        _loadError: false,
        enderecos: Array.isArray(client?.enderecos) ? this.normalizeClientAddresses(client.enderecos) : client?.enderecos
      }));
      this.clientSearchLastTerm = normalizedTerm;
      this.expandedClientId = null;
    }).catch(() => {
      if (reqId !== this.clientSearchReqSeq || !this.showClientModal) return;

      this.clientResults = [];
      this.expandedClientId = null;
      this.clientSearchError = true;
    }).finally(() => {
      if (reqId !== this.clientSearchReqSeq || !this.showClientModal) return;
      this.clientSearchLoading = false;
    });
  }

  private clearClientSearchTimer() {
    if (this.clientSearchTimer) {
      clearTimeout(this.clientSearchTimer);
      this.clientSearchTimer = null;
    }
  }

  private clearCentralPedidosBuscaTimer() {
    if (this.centralPedidosBuscaTimer) {
      clearTimeout(this.centralPedidosBuscaTimer);
      this.centralPedidosBuscaTimer = null;
    }
  }

  // ==========================================
  // PAGAMENTO
  // ==========================================
  handleFinalizeOrderAction() {
    if (this.salvando) return;
    if (this.centralPedidosAtivo && !this.centralAtendimentoPreparado) {
      this.showUiErrorToast('Loja destino pendente', 'Resolva a loja destino antes de finalizar.');
      return;
    }
    if (this.orderType === 'mesa') {
      this.finalizeMesaDirect();
      return;
    }
    this.openPayScreen();
  }

  openPayScreen() {
    if (this.orderType === 'mesa') {
      this.finalizeMesaDirect();
      return;
    }
    this.payScreen = true;
    this.payAddressRequirementTouched = false;
    this.showPayGrid = this.payMethods.length === 0;
    if (this.isMobile) {
      this.mCartOpen = false;
    }
  }

  closePayScreen() {
    this.payScreen = false;
  }

  get showCashbackPanel(): boolean {
    return this.orderType !== 'mesa' && this.cashbackAvailableAmount > 0;
  }

  get cashbackAvailableAmount(): number {
    return this.round2(Number(this.cashbackState?.cartao?.pontos || 0));
  }

  get hasCashbackPaymentMethodConfigured(): boolean {
    return !!this.cashbackState?.formaDePagamento;
  }

  get cashbackMaxUsable(): number {
    const baseWithoutCashback = this.payFinalTotalBeforeCashback;
    const deliveryFee = this.isDeliveryMode ? (parseFloat(this.deliveryFee) || 0) : 0;
    const limiteProdutos = Math.max(0, this.round2(baseWithoutCashback - deliveryFee));
    return this.round2(Math.min(this.cashbackAvailableAmount, limiteProdutos));
  }

  get cashbackAppliedValue(): number {
    if (!this.usarSaldoCashback || !this.cashbackState) return 0;
    return this.round2(Math.min(this.cashbackMaxUsable, Number(this.cashbackState.valor || 0)));
  }

  get payFinalTotalBeforeCashback(): number {
    return Math.max(0, Math.round((this.cartTotal - this.payDiscountVal) * 100) / 100);
  }

  activateCashbackUsage() {
    if (!this.cashbackState || !this.hasCashbackPaymentMethodConfigured) return;
    this.usarSaldoCashback = true;
    if (!this.cashbackState.valor) {
      this.cashbackState.valor = this.cashbackAvailableAmount;
    }
    this.cashbackState.valor = this.clampCashbackValue(this.cashbackState.valor);
    this.syncPayMethodsWithCurrentTotal();
  }

  disableCashbackUsage() {
    if (!this.cashbackState) return;
    this.usarSaldoCashback = false;
    this.cashbackState.valor = 0;
    this.syncPayMethodsWithCurrentTotal();
  }

  onCashbackValueChange() {
    if (!this.cashbackState) return;
    if (!this.usarSaldoCashback) {
      this.cashbackState.valor = 0;
      return;
    }
    this.cashbackState.valor = this.clampCashbackValue(this.cashbackState.valor);
    this.syncPayMethodsWithCurrentTotal();
  }

  private clampCashbackValue(value: any): number {
    const numeric = Math.max(0, this.round2(Number(value || 0)));
    return this.round2(Math.min(numeric, this.cashbackMaxUsable));
  }

  private initLoyaltyForSelectedContact() {
    const prevCashbackCardId = this.cashbackState?.cartao?.id;
    const prevCashbackValue = this.cashbackState?.valor || 0;
    const prevUsarSaldo = this.usarSaldoCashback;

    if (!this.selectedContact) {
      this.resetLoyaltyStates();
      return;
    }

    const cards = Array.isArray(this.selectedContact?.cartoes)
      ? this.selectedContact.cartoes
      : (Array.isArray(this.selectedContact?._fullDetails?.cartoes) ? this.selectedContact._fullDetails.cartoes : []);

    if (!cards.length) {
      this.resetLoyaltyStates();
      return;
    }

    const integracao = this.empresa?.integracaoPedidoFidelidade;
    if (integracao?.resgatarBrinde && integracao?.plano?.id) {
      const cartaoResgate = cards.find((item: any) => String(item?.plano?.id || '') === String(integracao.plano.id));
      this.resgateState = cartaoResgate ? {cartao: cartaoResgate, usar: true} : null;
      this.cashbackState = null;
      this.usarSaldoCashback = false;
      this.bindLoyaltyPaymentMethodsToStates();
      return;
    }

    let cashbackCard: any = null;
    let resgateCard: any = null;
    cards.forEach((cartao: any) => {
      const tipoAcumulo = this.normalizeText(cartao?.plano?.tipoDeAcumulo);
      if (!cashbackCard && tipoAcumulo === 'reais') {
        cashbackCard = cartao;
        return;
      }
      if (!resgateCard) {
        resgateCard = cartao;
      }
    });

    this.cashbackState = cashbackCard ? {
      cartao: cashbackCard,
      formaDePagamento: null,
      valor: String(prevCashbackCardId || '') === String(cashbackCard?.id || '') ? prevCashbackValue : 0
    } : null;
    this.resgateState = resgateCard ? {cartao: resgateCard, usar: true} : null;
    this.usarSaldoCashback = !!(this.cashbackState && prevUsarSaldo && String(prevCashbackCardId || '') === String(cashbackCard?.id || ''));
    this.bindLoyaltyPaymentMethodsToStates();
    if (this.cashbackState) {
      this.cashbackState.valor = this.clampCashbackValue(this.cashbackState.valor);
    }
  }

  private resetLoyaltyStates() {
    this.cashbackState = null;
    this.resgateState = null;
    this.usarSaldoCashback = false;
  }

  private syncPayMethodsWithCurrentTotal() {
    if (this.payMethods.length === 1) {
      this.payMethods = [{...this.payMethods[0], amount: this.round2(this.payFinalTotal)}];
    } else if (this.payMethods.length > 1) {
      this.payMethods = this.recalcRestante(this.payMethods);
    }
    this.refreshPayMethodSections();
  }

  get payDiscountVal(): number {
    const v = parseFloat(this.payDiscount) || 0;
    if (this.payDiscountType === '%') {
      return Math.round(this.cartTotal * v / 100 * 100) / 100;
    }
    return Math.round(v * 100) / 100;
  }

  get payFinalTotal(): number {
    return Math.max(0, Math.round((this.payFinalTotalBeforeCashback - this.cashbackAppliedValue) * 100) / 100);
  }

  get payPaidTotal(): number {
    return this.round2(this.payMethods.reduce((s, m) => s + this.toAmount(m.amount), 0));
  }

  get payRemaining(): number {
    return Math.max(0, Math.round((this.payFinalTotal - this.payPaidTotal) * 100) / 100);
  }

  get isSplit(): boolean {
    return this.payMethods.length > 1;
  }

  get restanteIdx(): number {
    if (this.payMethods.length === 2) return 0;
    return this.payMethods.length - 1;
  }

  get splitFormsWithValue(): number {
    return this.payMethods.filter(m => this.toAmount(m.amount) > 0).length;
  }

  get splitValid(): boolean {
    return this.splitFormsWithValue >= 2 && this.payRemaining === 0;
  }

  get splitHasEmpty(): boolean {
    return this.payMethods.some(m => this.toAmount(m.amount) === 0);
  }

  get splitOverflow(): boolean {
    return this.payPaidTotal > this.payFinalTotal;
  }

  get hasFiadoSelected(): boolean {
    return this.payMethods.some((m: any) => m?.original?.fiado === true);
  }

  get hasOnlinePaymentSelected(): boolean {
    return this.payMethods.some((m: any) => {
      const forma = m?.original;
      return this.isExplicitTrue(forma?.online) || this.normalizeText(forma?.formaDePagamentoPdv?.tipo) === 'online';
    });
  }

  get canMarkOrderPaidOnCreate(): boolean {
    return this.orderType !== 'mesa' && !this.payLater && !this.hasFiadoSelected && !this.hasOnlinePaymentSelected;
  }

  get canConfirm(): boolean {
    if (this.orderType === 'mesa') return true;
    if (this.hasFiadoSelected && this.cashbackAppliedValue > 0) return false;
    if (this.payLater) return true;
    if (this.payFinalTotal === 0) return true;
    if (this.payMethods.length === 0) return false;
    if (this.payMethods.length === 1) return true;
    return this.isSplit && this.splitValid && !this.splitHasEmpty && !this.splitOverflow;
  }

  get deliveryAddressRequired(): boolean {
    return this.isDeliveryMode;
  }

  get hasDeliveryAddressSelected(): boolean {
    return !!this.selectedAddress;
  }

  get canConfirmPaymentFlow(): boolean {
    return this.canConfirm
      && (!this.deliveryAddressRequired || this.hasDeliveryAddressSelected)
      && !this.agendamentoIncompleto;
  }

  get shouldShowMissingDeliveryAddressAlert(): boolean {
    return this.payScreen && this.deliveryAddressRequired && !this.hasDeliveryAddressSelected && this.payAddressRequirementTouched;
  }

  get payCtaLabel(): string {
    if (this.orderType === 'mesa') {
      return `Confirmar Pedido ${this.formatCurrency(this.payFinalTotal)}`;
    }
    if (this.deliveryAddressRequired && !this.hasDeliveryAddressSelected) {
      return 'Selecione um endereço de entrega';
    }
    if (this.hasFiadoSelected && this.cashbackAppliedValue > 0) {
      return 'Fiado não pode ser combinado com cashback';
    }
    if (this.payLater) {
      return `Confirmar Pedido ${this.formatCurrency(this.payFinalTotal)}`;
    }
    if (this.agendamentoIncompleto) {
      if (!this.dataAgendamento) return 'Informe a data do agendamento';
      return 'Informe a hora do agendamento';
    }
    if (this.payMethods.length === 0 && this.payFinalTotal > 0) {
      return 'Selecione a forma de pagamento';
    }
    if (this.isSplit && (this.splitHasEmpty || this.splitOverflow || this.payRemaining > 0)) {
      return 'Ajuste a divisão do pagamento';
    }
    return `Confirmar Pedido ${this.formatCurrency(this.payFinalTotal)}`;
  }

  get isCompact(): boolean {
    return this.payMethods.length >= 3;
  }

  get filteredPayMethodSections(): PayMethodSectionVM[] {
    return this.payMethodSectionsView;
  }

  get hasDinheiro(): boolean {
    return this.payMethods.some(m => (m.name || '').toLowerCase().includes('dinheiro'));
  }

  get dinheiroMethod(): any {
    return this.payMethods.find(m => (m.name || '').toLowerCase().includes('dinheiro'));
  }

  get trocoValue(): number {
    const trocoInput = parseFloat(this.payTroco) || 0;
    if (this.isSplit && this.dinheiroMethod) {
      return Math.max(0, Math.round((trocoInput - this.toAmount(this.dinheiroMethod.amount)) * 100) / 100);
    }
    return Math.max(0, Math.round((trocoInput - this.payFinalTotal) * 100) / 100);
  }

  private round2(value: number): number {
    return Math.round((value || 0) * 100) / 100;
  }

  private toAmount(value: any): number {
    return this.round2(parseFloat(value) || 0);
  }

  private refreshPayMethodSections() {
    const selectedIds = new Set(
      this.payMethods
        .map((m: any) => String(m?.id ?? '').trim())
        .filter((id: string) => !!id)
    );
    const available = this.availablePayMethods.filter((m: PayMethodVM) =>
      !selectedIds.has(String(m.id).trim())
    );
    this.payMethodSectionsView = this.buildPayMethodSections(available);
  }

  selectPayMethod(method: PayMethodVM) {
    if (!method) return;
    const methodId = String(method.id ?? '').trim();
    if (!methodId) return;
    const isFiado = method?.original?.fiado === true;
    const exists = this.payMethods.find((m: any) => String(m.id) === methodId);

    if (isFiado) {
      this.payMethods = [{...method, id: methodId, amount: this.round2(this.payFinalTotal)}];
      this.showPayGrid = false;
      this.refreshPayMethodSections();
      this.syncMarkOrderPaidOption();
      this.payTroco = '';
      return;
    }

    if (this.payMethods.some((m: any) => m?.original?.fiado === true)) {
      this.payMethods = [];
    }

    if (exists) {
      const remaining = this.payMethods.filter((m: any) => String(m.id) !== methodId);
      if (remaining.length === 1) {
        remaining[0] = {...remaining[0], amount: this.round2(this.payFinalTotal)};
        this.payMethods = [...remaining];
      } else {
        this.payMethods = remaining.length > 1 ? this.recalcRestante(remaining) : [...remaining];
      }
      if (this.payMethods.length === 0) this.showPayGrid = true;
    } else {
      const updated = [...this.payMethods, {
        ...method,
        id: methodId,
        amount: 0
      }];

      if (updated.length === 1) {
        updated[0].amount = this.round2(this.payFinalTotal);
        this.payMethods = [...updated];
      } else {
        this.payMethods = this.recalcRestante(updated);
      }
      this.showPayGrid = false;
    }

    this.refreshPayMethodSections();
    this.syncMarkOrderPaidOption();
    this.payTroco = '';
  }

  removePayMethod(methodId: any) {
    const normalizedId = String(methodId);
    const remaining = this.payMethods.filter((m: any) => String(m.id) !== normalizedId);

    if (remaining.length === 1) {
      remaining[0] = {...remaining[0], amount: this.round2(this.payFinalTotal)};
      this.payMethods = [...remaining];
    } else {
      this.payMethods = remaining.length > 1 ? this.recalcRestante(remaining) : [...remaining];
    }

    if (this.payMethods.length === 0) this.showPayGrid = true;
    this.refreshPayMethodSections();
    this.syncMarkOrderPaidOption();
    this.payTroco = '';
  }

  onPayAmountChange(index: number) {
    if (!this.payMethods[index]) return;
    this.payMethods[index].amount = this.toAmount(this.payMethods[index].amount);
    if (this.payMethods.length > 1) {
      this.payMethods = this.recalcRestante(this.payMethods);
    }
  }

  recalcRestante(methods: any[] = this.payMethods): any[] {
    const updated = (methods || []).map((m: any) => ({...m}));
    if (updated.length < 2) return updated;
    const rIdx = updated.length === 2 ? 0 : updated.length - 1;
    let otherSum = 0;
    for (let i = 0; i < updated.length; i++) {
      if (i !== rIdx) otherSum += this.toAmount(updated[i].amount);
    }
    updated[rIdx].amount = this.round2(Math.max(0, this.payFinalTotal - otherSum));
    return updated;
  }

  openAddPayMethod() {
    this.showPayGrid = true;
  }

  get canUsePayLater(): boolean {
    return !!(this.empresa && this.constantsService.possuiModulo(this.empresa, ModulosEnum.FIADO) &&
      this.orderType !== 'mesa' && this.selectedContact && this.selectedContact.id);
  }

  togglePayLater() {
    this.payLater = !this.payLater;
    if (this.payLater) {
      this.payMethods = [];
      this.marcarPedidoComoPago = false;
      this.showPayGrid = false;
      this.payTroco = '';
    } else {
      this.showPayGrid = true;
    }
    this.refreshPayMethodSections();
  }

  toggleMarkOrderPaid(checked: boolean) {
    this.marcarPedidoComoPago = this.canMarkOrderPaidOnCreate && checked;
  }

  private syncMarkOrderPaidOption() {
    if (!this.canMarkOrderPaidOnCreate) {
      this.marcarPedidoComoPago = false;
    }
  }

  private getLegacyAdditionalFieldsForProduct(product: any): any[] {
    const campos = this.getSelProductCampos(product);
    const fields: any[] = [];

    campos.forEach((adic: any, index: number) => {
      const fieldKey = this.getFieldKey(adic, index);
      const rawOptions = this.getCampoOptionsSource(adic).filter((op: any) => !!op);
      if (!rawOptions.length) return;

      const options = rawOptions.map((rawOption: any, optionIndex: number) => ({
        id: rawOption?.id ?? rawOption?.opcaoId ?? null,
        name: rawOption?.nome || rawOption?.descricao || `Opcao ${optionIndex + 1}`,
        price: Number(rawOption?.valor ?? rawOption?.preco ?? 0),
        fieldId: adic?.id,
        fieldKey,
        optionKey: this.getOptionKey(rawOption, fieldKey),
        raw: rawOption
      }));

      fields.push({
        id: adic?.id,
        fieldKey,
        name: adic?.nome || 'Adicional',
        kind: this.classifyAdicionalKind(adic),
        raw: adic,
        options
      });
    });

    return fields;
  }

  private getLegacyExtraMatchKey(extra: any): string {
    const fieldId = extra?.fieldId ?? '';
    const optionId = extra?.id ?? '';
    const optionKey = extra?.optionKey ?? '';
    const name = this.normalizeText(extra?.name || extra?.nome);
    return [String(fieldId), String(optionId), String(optionKey), name].join('::');
  }

  private buildLegacyCartExtrasIndex(item: any): any {
    const byFieldOptionId = new Map<string, any>();
    const byFieldOptionKey = new Map<string, any>();
    const byFieldNameOptionName = new Map<string, any>();
    const selectedExtras = (Array.isArray(item?.extras) ? item.extras : [])
      .filter((extra: any) => Number(extra?.qty || 0) > 0);

    for (const extra of selectedExtras) {
      if (extra?.fieldId !== undefined && extra?.fieldId !== null && extra?.id !== undefined && extra?.id !== null) {
        byFieldOptionId.set(`${String(extra.fieldId)}::${String(extra.id)}`, extra);
      }

      if (extra?.fieldKey && extra?.optionKey) {
        byFieldOptionKey.set(`${String(extra.fieldKey)}::${String(extra.optionKey)}`, extra);
      }

      const fieldNameKey = this.normalizeText(extra?.fieldName || extra?.groupName);
      const optionNameKey = this.normalizeText(extra?.name || extra?.nome);
      if (fieldNameKey && optionNameKey) {
        byFieldNameOptionName.set(`${fieldNameKey}::${optionNameKey}`, extra);
      }
    }

    return {
      byFieldOptionId,
      byFieldOptionKey,
      byFieldNameOptionName,
      selectedExtras
    };
  }

  private findLegacySelectedExtraForOption(field: any, option: any, extrasIndex: any): any {
    if (!field || !option || !extrasIndex) return null;

    if (field?.id !== undefined && field?.id !== null && option?.id !== undefined && option?.id !== null) {
      const byId = extrasIndex.byFieldOptionId.get(`${String(field.id)}::${String(option.id)}`);
      if (byId) return byId;
    }

    if (field?.fieldKey && option?.optionKey) {
      const byOptionKey = extrasIndex.byFieldOptionKey.get(`${String(field.fieldKey)}::${String(option.optionKey)}`);
      if (byOptionKey) return byOptionKey;
    }

    const fieldNameKey = this.normalizeText(field?.name);
    const optionNameKey = this.normalizeText(option?.name || option?.raw?.nome);
    if (fieldNameKey && optionNameKey) {
      const byName = extrasIndex.byFieldNameOptionName.get(`${fieldNameKey}::${optionNameKey}`);
      if (byName) return byName;
    }

    return null;
  }

  private buildLegacyOptionSnapshot(field: any, option: any): any {
    const raw = (option?.raw && typeof option.raw === 'object') ? option.raw : {};
    const snapshot: any = {...raw};

    if (snapshot.id === undefined || snapshot.id === null || snapshot.id === '') {
      snapshot.id = option?.id;
    }
    if (!snapshot.nome) {
      snapshot.nome = option?.name || '';
    }
    if (snapshot.valor === undefined || snapshot.valor === null || snapshot.valor === '') {
      snapshot.valor = Number(option?.price || 0);
    }
    if (snapshot.disponivel === undefined) {
      snapshot.disponivel = true;
    }
    if (!Array.isArray(snapshot.dependencias)) {
      snapshot.dependencias = [];
    }
    if (snapshot.idAdicional === undefined || snapshot.idAdicional === null || snapshot.idAdicional === '') {
      snapshot.idAdicional = field?.id ?? field?.raw?.id;
    }
    if (!snapshot.adicional || typeof snapshot.adicional !== 'object') {
      snapshot.adicional = {id: snapshot.idAdicional};
    } else if (snapshot.adicional.id === undefined || snapshot.adicional.id === null || snapshot.adicional.id === '') {
      snapshot.adicional = {...snapshot.adicional, id: snapshot.idAdicional};
    }

    return snapshot;
  }

  private getLegacyListOptionPayloadKey(option: any, optionIndex: number): string {
    if (option?.id !== undefined && option?.id !== null && option?.id !== '') {
      return `opcao_${String(option.id)}`;
    }
    const slug = this.normalizeText(option?.name || option?.raw?.nome || `opcao_${optionIndex + 1}`)
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '');
    return `opcao_${slug || optionIndex}`;
  }

  private buildLegacyAdicionaisPayload(item: any): {adicionais: any; valoresAdicionais: any[]} {
    const fields = this.getLegacyAdditionalFieldsForProduct(item?.product);
    const extrasIndex = this.buildLegacyCartExtrasIndex(item);
    const adicionais: any = {};
    const listValues: any[] = [];
    const singleValues: any[] = [];
    const matchedExtraKeys = new Set<string>();

    let singleIndex = 0;
    let listIndex = 0;

    for (const field of fields) {
      if (field.kind === 'single') {
        const selectedOption = field.options.find((option: any) => !!this.findLegacySelectedExtraForOption(field, option, extrasIndex));
        if (selectedOption) {
          const selectedExtra = this.findLegacySelectedExtraForOption(field, selectedOption, extrasIndex);
          if (selectedExtra) {
            matchedExtraKeys.add(this.getLegacyExtraMatchKey(selectedExtra));
          }
          const snapshot = this.buildLegacyOptionSnapshot(field, selectedOption);
          adicionais[`escolhido_campo${singleIndex}`] = snapshot?.id;
          adicionais[`campo${singleIndex}`] = snapshot;
          adicionais[`meta_campo${singleIndex}`] = {
            multiplicaQuantidadeProduto: field?.raw?.multiplicaQuantidadeProduto !== false
          };
          singleValues.push({
            nome: snapshot?.nome || selectedOption?.name || field?.name || 'Adicional',
            qtde: Math.max(1, Number(selectedExtra?.qty || 1))
          });
        }
        singleIndex += 1;
        continue;
      }

      const listPayload: any = {
        totalSelecionado: 0,
        tipoDeCobranca: field?.raw?.tipoDeCobranca || 'SOMA',
        multiplicaQuantidadeProduto: field?.raw?.multiplicaQuantidadeProduto !== false
      };

      field.options.forEach((option: any, optionIndex: number) => {
        const selectedExtra = this.findLegacySelectedExtraForOption(field, option, extrasIndex);
        const qty = Math.max(0, Number(selectedExtra?.qty || 0));
        const selecionada = qty > 0;
        if (selectedExtra) {
          matchedExtraKeys.add(this.getLegacyExtraMatchKey(selectedExtra));
        }

        const snapshot = this.buildLegacyOptionSnapshot(field, option);
        const optionPayload: any = {
          selecionada,
          opcao: snapshot,
          qtde: qty
        };

        if (selecionada) {
          const optionValue = Number(snapshot?.valor ?? option?.price ?? 0);
          optionPayload.valorTotal = this.round2(optionValue * qty);
          listValues.push({
            nome: snapshot?.nome || option?.name || field?.name || 'Adicional',
            qtde: qty
          });
        }

        listPayload[this.getLegacyListOptionPayloadKey(option, optionIndex)] = optionPayload;
        listPayload.totalSelecionado += qty;
      });

      adicionais[`lista${listIndex}`] = listPayload;
      listIndex += 1;
    }

    const unmatchedValues = (extrasIndex.selectedExtras || [])
      .filter((extra: any) => !matchedExtraKeys.has(this.getLegacyExtraMatchKey(extra)))
      .map((extra: any) => ({
        nome: extra?.name || extra?.nome || 'Adicional',
        qtde: Math.max(1, Number(extra?.qty || 1))
      }));

    return {
      adicionais,
      valoresAdicionais: [...listValues, ...singleValues, ...unmatchedValues]
    };
  }

  // ==========================================
  // CONFIRMAR PEDIDO
  // ==========================================
  handlePayCTA() {
    if (this.orderType === 'mesa') {
      this.finalizeMesaDirect();
      return;
    }
    if (!this.ensureDeliveryAddressRequirement()) {
      return;
    }
    if (!this.ensureAgendamentoRequirement()) {
      return;
    }
    if (this.canConfirm) {
      this.confirmOrder();
    } else {
      const el = document.getElementById('payGrid');
      if (el) el.scrollIntoView({behavior: 'smooth'});
    }
  }

  confirmOrder() {
    if (this.orderType === 'mesa') {
      this.finalizeMesaDirect();
      return;
    }
    if (this.salvando) return;
    if (!this.ensureDeliveryAddressRequirement()) return;
    this.salvando = true;

    const objPedido = this.buildOrderObject();
    const origemSalvar = this.resolveSaveOrigemParam();

    this.pedidosService.salvePedido(objPedido, origemSalvar).then((resp: any) => {
      this.salvando = false;
      const redirectUrl = this.buildPostSaveRedirectUrl(resp, {editando: false});
      this.router.navigateByUrl(redirectUrl).then(() => {}).catch(() => {
        this.showUiErrorToast(
          'Pedido salvo',
          'O pedido foi salvo, mas nao foi possivel redirecionar automaticamente.'
        );
      });
    }).catch((err) => {
      this.salvando = false;
      this.showUiErrorToast(
        'Nao foi possivel salvar o pedido',
        this.extractErrorText(err, 'Tente novamente em alguns instantes.')
      );
    });
  }

  private finalizeMesaDirect() {
    if (this.salvando) return;
    if (!this.validateMesaBeforeSave()) return;

    this.salvando = true;

    const objPedido = this.buildOrderObject();
    const origemSalvar = this.resolveSaveOrigemParam();

    this.pedidosService.salvePedido(objPedido, origemSalvar).then((resp: any) => {
      const redirectUrl = this.buildPostSaveRedirectUrl(resp, {editando: false});
      this.showUiSuccessToast('Pedido enviado', this.buildMesaSuccessToastMessage(), 350);
      this.scheduleMesaSuccessRedirect(redirectUrl, 0);
    }).catch((err) => {
      this.salvando = false;
      this.showUiErrorToast(
        'Nao foi possivel adicionar itens na mesa',
        this.extractErrorText(err, 'Verifique a comanda e tente novamente.')
      );
    });
  }

  private validateMesaBeforeSave(): boolean {
    if (!this.cart?.length) {
      this.showUiErrorToast(
        'Pedido incompleto',
        'Selecione ao menos um item antes de finalizar o pedido da mesa.'
      );
      return false;
    }

    const mesaPayload = this.buildMesaPayloadForOrder();
    if (!mesaPayload || (!mesaPayload.id && !this.routeContext.idMesa)) {
      this.showUiErrorToast(
        'Mesa nao identificada',
        'Abra o pedido a partir da tela de mesas para continuar.'
      );
      return false;
    }

    const contatoPayload = this.buildContatoPayloadForOrder();
    const exigeContato = !(this.empresa?.pedidoMesaNaoIdentificado);
    if (exigeContato) {
      if (!contatoPayload?.telefone) {
        this.showUiErrorToast(
          'Cliente nao identificado',
          'Informe o telefone do cliente para pedidos de mesa.'
        );
        return false;
      }
      if ((contatoPayload.codigoPais || '+55') === '+55' && String(contatoPayload.telefone || '').length < 10) {
        this.showUiErrorToast(
          'Telefone incompleto',
          'Informe um telefone completo com DDD.'
        );
        return false;
      }
    }

    return true;
  }

  private buildMesaSuccessRedirectUrl(resp: any): string {
    return this.buildPostSaveRedirectUrl(resp, {editando: false});
  }

  private buildPostSaveRedirectUrl(resp: any, opts: {editando?: boolean} = {}): string {
    let urlDestino = this.routeContext?.urlRetorno || '';

    if (!urlDestino) {
      if (this.centralPedidosAtivo) {
        urlDestino = '/admin-grupo/index';
      } else if (this.orderType === 'mesa') {
        urlDestino = '/admin/pedidos-mesas';
      } else {
        const telefoneRedirect = this.getRedirectContatoTelefoneCompleto();
        urlDestino = telefoneRedirect
          ? '/admin/contatos/iframe/' + encodeURIComponent(telefoneRedirect)
          : '/admin/pedidos';
      }
    }

    const guid = String(resp?.guid || resp?.codigo || '');
    const msg = opts.editando ? 'Pedido atualizado com sucesso!' : 'Pedido criado com sucesso!';
    const parametros: string[] = [
      'msg=' + encodeURIComponent(msg),
      'codigo=' + encodeURIComponent(guid)
    ];

    if (resp?.gerarMensagemlinkPagamento && guid) {
      parametros.push('gmlkpg=' + encodeURIComponent(guid));
    }

    const params = parametros.join('&');
    return urlDestino.indexOf('?') !== -1 ? `${urlDestino}&${params}` : `${urlDestino}?${params}`;
  }

  private getRedirectContatoTelefoneCompleto(): string | null {
    if (this.isBalcaoMode) {
      return null;
    }

    const fromSelected = this.selectedContact
      ? `${this.selectedContact.codigoPais || '+55'}${this.selectedContact.telefone || ''}`
      : '';
    if (this.isValidRedirectPhone(fromSelected)) return fromSelected;

    const contatoPayload = this.buildContatoPayloadForOrder();
    const fromPayload = contatoPayload
      ? `${contatoPayload.codigoPais || '+55'}${contatoPayload.telefone || ''}`
      : '';
    if (this.isValidRedirectPhone(fromPayload)) return fromPayload;

    const fromRoute = (this.routeContext?.tel || '').toString().trim();
    if (this.isValidRedirectPhone(fromRoute)) return fromRoute;

    return null;
  }

  private isValidRedirectPhone(rawPhone: any): boolean {
    const phone = (rawPhone || '').toString().trim();
    if (!phone) return false;

    const digits = phone.replace(/\D+/g, '');
    if (!digits) return false;

    const withoutCountry = digits.startsWith('55') ? digits.slice(2) : digits;
    if (withoutCountry === '00000000000') return false;
    if (withoutCountry === '0000000000') return false;
    return true;
  }

  private buildFormaDeEntregaPayload(): any | null {
    if (this.orderType === 'mesa' || this.isBalcaoMode) return null;

    if (this.isDeliveryMode) {
      return {id: 2, nome: 'Receber em casa'};
    }

    return {id: 1, nome: 'Retirar'};
  }

  private getFormaDeEntregaEmpresaAtual(): any {
    if (this.orderType === 'mesa' || this.isBalcaoMode) return null;
    const forma = this.buildFormaDeEntregaPayload();
    if (!forma) return null;
    const formas = this.empresa?.formasDeEntrega;
    if (!Array.isArray(formas) || !formas.length) return null;
    return formas.find((f: any) => f?.nome === forma.nome) || null;
  }

  get permiteAgendamentoPedido(): boolean {
    return !!this.getFormaDeEntregaEmpresaAtual()?.permiteAgendamento;
  }

  get agendamentoObrigatorio(): boolean {
    const forma = this.getFormaDeEntregaEmpresaAtual();
    return !!(forma?.permiteAgendamento && forma?.agendamentoObrigatorio);
  }

  get pedirHorarioAgendamento(): boolean {
    return !this.empresa?.naoPerguntarHorario;
  }

  syncAgendamentoObrigatorio() {
    if (this.agendamentoObrigatorio && !this.agendarEntrega) {
      this.agendarEntrega = true;
      this.agoraAgendamento = new Date();
    }
  }

  get agendamentoIncompleto(): boolean {
    if (!this.agendarEntrega) return false;
    if (!this.permiteAgendamentoPedido) return false;
    if (!this.dataAgendamento) return true;
    if (this.pedirHorarioAgendamento && !this.horaAgendamento) return true;
    return false;
  }

  onToggleAgendarEntrega(checked: boolean) {
    if (this.agendamentoObrigatorio) {
      this.agendarEntrega = true;
      this.agoraAgendamento = new Date();
      return;
    }
    this.agendarEntrega = !!checked;
    if (!this.agendarEntrega) {
      this.dataAgendamento = null;
      this.horaAgendamento = null;
      this.payAgendamentoRequirementTouched = false;
    } else {
      this.agoraAgendamento = new Date();
    }
  }

  get dataAgendamentoInvalida(): boolean {
    return this.payAgendamentoRequirementTouched
      && this.agendarEntrega
      && !this.dataAgendamento;
  }

  get horaAgendamentoInvalida(): boolean {
    return this.payAgendamentoRequirementTouched
      && this.agendarEntrega
      && this.pedirHorarioAgendamento
      && !this.horaAgendamento;
  }

  onDataAgendamentoChange(valor: Date | null) {
    this.dataAgendamento = valor;
    if (valor) this.payAgendamentoRequirementTouched = this.horaAgendamentoInvalida;
  }

  onHoraAgendamentoChange(valor: Date | null) {
    this.horaAgendamento = valor;
    if (valor) this.payAgendamentoRequirementTouched = this.dataAgendamentoInvalida;
  }

  private ensureAgendamentoRequirement(): boolean {
    if (!this.agendamentoIncompleto) {
      this.payAgendamentoRequirementTouched = false;
      return true;
    }
    this.payAgendamentoRequirementTouched = true;
    return false;
  }

  private buildHorarioEntregaAgendada(): Date | null {
    if (!this.permiteAgendamentoPedido) return null;
    if (!this.agendarEntrega || !this.dataAgendamento) return null;
    const data = new Date(this.dataAgendamento);
    if (this.pedirHorarioAgendamento && this.horaAgendamento) {
      const hora = new Date(this.horaAgendamento);
      data.setHours(hora.getHours(), hora.getMinutes(), 0, 0);
    } else {
      data.setHours(0, 0, 0, 0);
    }
    return data;
  }

  private buildMesaSuccessToastMessage(): string {
    const mesaLabel = this.mesaNumeroDestaque && this.mesaNumeroDestaque !== '--'
      ? `Mesa ${this.mesaNumeroDestaque}`
      : 'Mesa';
    const comandaLabel = this.mesaComandaDestaque ? ` • Comanda ${this.mesaComandaDestaque}` : '';
    return `Itens adicionados em ${mesaLabel}${comandaLabel}`;
  }

  private scheduleMesaSuccessRedirect(url: string, delayMs: number) {
    this.clearMesaRedirectTimer();
    this.mesaRedirectTimer = setTimeout(() => {
      this.mesaRedirectTimer = null;
      this.router.navigateByUrl(url).then(() => {
        this.salvando = false;
      }).catch(() => {
        this.salvando = false;
        this.showUiErrorToast(
          'Pedido enviado',
          'Os itens foram adicionados, mas nao foi possivel voltar para a tela de mesas automaticamente.'
        );
      });
    }, Math.max(0, delayMs || 0));
  }

  private buildOrderObject() {
    const itens = this.cart.map(item => {
      const legacyAdicionais = this.buildLegacyAdicionaisPayload(item);
      const obj: any = {
        produto: {id: item.pid, nome: item.name},
        qtde: item.qty,
        observacao: item.obs || '',
        desconto: item.disc || 0,
        adicionais: legacyAdicionais.adicionais || {}
      };
      if (legacyAdicionais.valoresAdicionais?.length) {
        obj.valoresAdicionais = legacyAdicionais.valoresAdicionais;
      }
      return obj;
    });

    const pagamentos: any[] = [];
    if (this.orderType !== 'mesa' && this.cashbackAppliedValue > 0 && this.cashbackState?.cartao && this.cashbackState?.formaDePagamento) {
      const pagamentoCashback: any = {
        valor: this.cashbackAppliedValue,
        cartao: this.cashbackState.cartao,
        formaDePagamento: this.cashbackState.formaDePagamento
      };
      if (this.cashbackState.id) {
        pagamentoCashback.id = this.cashbackState.id;
      }
      pagamentos.push(pagamentoCashback);
    }

    if (this.orderType !== 'mesa') {
      (this.payMethods || []).forEach((m: any) => {
        pagamentos.push({
          formaDePagamento: m.original || {id: m.id, nome: m.name},
          valor: this.toAmount(m.amount),
          trocoPara: (m.name || '').toLowerCase().includes('dinheiro') ? (parseFloat(this.payTroco) || 0) : 0
        });
      });
    }

    const origemPayload = this.resolvePayloadOrigem();
    const obj: any = {
      itens,
      pagamentos,
      observacoes: this.payObs || '',
      desconto: this.payDiscountVal || 0,
      pago: this.canMarkOrderPaidOnCreate && this.marcarPedidoComoPago === true
    };
    if (origemPayload) obj.origem = origemPayload;

    const formaDeEntrega = this.buildFormaDeEntregaPayload();
    if (formaDeEntrega) {
      obj.formaDeEntrega = formaDeEntrega;
    }

    const horarioEntregaAgendada = this.buildHorarioEntregaAgendada();
    if (horarioEntregaAgendada) {
      obj.horarioEntregaAgendada = horarioEntregaAgendada;
    }

    const contatoPayload = this.buildContatoPayloadForOrder();
    if (contatoPayload) obj.contato = contatoPayload;

    if (this.isDeliveryMode) {
      if (this.selectedAddress) {
        const enderecoPayload = this.normalizeAddressForLegacyApi(this.selectedAddress);
        obj.endereco = enderecoPayload;
        if (enderecoPayload?.taxaCalculadaId) {
          obj.taxaCalculadaId = enderecoPayload.taxaCalculadaId;
        }
        if (enderecoPayload?.hash) {
          obj.hash = enderecoPayload.hash;
        }
      } else if (this.customerAddress) {
        obj.enderecoString = this.customerAddress;
      }
      obj.taxaEntrega = parseFloat(this.deliveryFee) || 0;
    }

    if (this.isBalcaoMode) {
      obj.identificacaoBalcao = (this.identificacaoBalcao || '').trim() ;
      obj.contato = null;
    }

    if (this.orderType === 'mesa') {
      const mesaPayload = this.buildMesaPayloadForOrder();
      if (mesaPayload) {
        obj.mesa = mesaPayload;
      }

      const garcomPayload = this.buildGarcomPayloadForOrder();
      if (garcomPayload) {
        obj.garcom = garcomPayload;
      }

      if (this.routeContext.idComanda) {
        obj.idComanda = this.routeContext.idComanda;
      }

      if (this.routeContext.novaComanda) {
        obj.novaComanda = true;
      }

      if (this.cartaoClienteSelecionado?.id) {
        obj.idCartaoCliente = this.cartaoClienteSelecionado.id;
      }
    } else if (this.tableNum) {
      obj.mesa = {numero: this.tableNum};
    }

    if (this.payCupom) {
      obj.cupom = {codigo: this.payCupom};
    }

    return obj;
  }

  private resolvePayloadOrigem(): EnumOrigemPedido | null {
    if (this.routeContext.centralPedidos) {
      return EnumOrigemPedido.CentralPedidos;
    }
    if (this.isBalcaoMode) {
      return EnumOrigemPedido.Balcao;
    }
    if (this.orderType === 'mesa') {
      return this.buildGarcomPayloadForOrder() ? EnumOrigemPedido.Garcom : null;
    }
    if (this.orderType === 'balcao') {
      return EnumOrigemPedido.Balcao;
    }
    return EnumOrigemPedido.Admin;
  }

  private resolveSaveOrigemParam(): EnumOrigemPedido | null {
    return this.resolvePayloadOrigem();
  }

  private buildContatoPayloadForOrder(): any | null {
    if (this.isBalcaoMode) {
      return null;
    }

    if (this.selectedContact) {
      return {
        id: this.selectedContact.id,
        nome: this.selectedContact.nome || this.customerName || this.routeContext.nome || 'Cliente',
        telefone: this.selectedContact.telefone,
        codigoPais: this.selectedContact.codigoPais || '+55',
        naoIdentificado: !!this.selectedContact.naoIdentificado
      };
    }

    const fromRoute = this.buildManualContactFromRoute();
    if (fromRoute) return fromRoute;

    if (this.orderType === 'mesa') {
      if (this.empresa?.pedidoMesaNaoIdentificado) {
        return this.buildFallbackMesaContact();
      }
      return null;
    }

    return null;
  }

  private buildManualContactFromRoute(): any | null {
    const telCompleto = (this.routeContext.tel || this.customerPhone || '').trim();
    const nome = (this.routeContext.nome || this.customerName || '').trim();
    if (!telCompleto) return null;

    const parsed = this.contatosService.extraiCodigoPaisETelefone(telCompleto);
    if (!parsed?.telefone) return null;

    return {
      nome: nome || 'Cliente',
      telefone: parsed.telefone,
      codigoPais: parsed.codigoPais || '+55'
    };
  }

  private buildFallbackMesaContact(): any {
    const nome = (this.customerName || this.routeContext.nome || 'Consumidor não identificado').trim();
    return {
      telefone: '00000000000',
      codigoPais: '+55',
      nome: nome || 'Consumidor não identificado',
      naoIdentificado: true
    };
  }

  private buildMesaPayloadForOrder(): any | null {
    const mesa = this.mesaSelecionada;
    if (mesa?.id) {
      return mesa;
    }

    if (this.routeContext.idMesa) {
      return {
        id: Number(this.routeContext.idMesa) || this.routeContext.idMesa,
        numero: this.tableNum || undefined
      };
    }

    if (this.tableNum) {
      return {numero: this.tableNum};
    }

    return null;
  }

  private buildGarcomPayloadForOrder(): any | null {
    if (this.garcomSelecionado?.id) return this.garcomSelecionado;
    return null;
  }

  // ==========================================
  // MODAL VENDA REGISTRADA
  // ==========================================
  closeOrderDone() {
    if (this.orderType === 'mesa') {
      this.router.navigateByUrl(this.routeContext?.urlRetorno || '/admin/pedidos-mesas').then(() => {});
      return;
    }
    this.orderDone = false;
    this.payScreen = false;
    this.startNewOrder();
  }

  private showUiErrorToast(title: string, message: string) {
    this.showUiToastKendo('error', title, message, 7000);
  }

  private showUiSuccessToast(title: string, message: string, autoCloseMs: number = 900) {
    this.showUiToastKendo('success', title, message, autoCloseMs);
  }

  private showUiToastKendo(type: 'error' | 'success', title: string, message: string, autoCloseMs: number) {
    const titleText = (title || (type === 'success' ? 'Sucesso' : 'Erro')).trim();
    const messageText = (message || 'Tente novamente.').trim();
    const content = messageText ? `${titleText}: ${messageText}` : titleText;

    if (this.uiNotificationRef) {
      this.uiNotificationRef.hide();
      this.uiNotificationRef = null;
    }

    this.uiNotificationRef = this.notificationService.show({
      content,
      hideAfter: Math.max(0, autoCloseMs || 0),
      position: {horizontal: 'center', vertical: 'top'},
      animation: {type: 'fade', duration: 250},
      cssClass: 'pdv-v3-kendo-toast',
      type: {style: type, icon: true}
    });
  }

  private clearMesaRedirectTimer() {
    if (this.mesaRedirectTimer) {
      clearTimeout(this.mesaRedirectTimer);
      this.mesaRedirectTimer = null;
    }
  }

  private extractErrorText(err: any, fallback: string): string {
    if (!err) return fallback;
    if (typeof err === 'string') return err;

    const candidates = [
      err?.message,
      err?.erro,
      err?.error,
      err?.mensagem,
      err?.response?.message,
      err?.response?.erro,
      err?.response?.error
    ];

    for (const candidate of candidates) {
      if (candidate && String(candidate).trim()) {
        return String(candidate).trim();
      }
    }

    return fallback;
  }

  private resolveRouteOrderTypeParam() {
    const queryParams: any = this.activatedRoute?.snapshot?.queryParams || {};
    const routeConfigPath = this.activatedRoute?.snapshot?.routeConfig?.path || '';
    const urlAtual = this.router?.url || '';
    const isBalcaoRoute = queryParams.bal != null && this.parseBooleanishQueryParam(queryParams.bal, true);
    const isCentralRoute = urlAtual.indexOf('/admin-grupo/central-pedidos') >= 0 || routeConfigPath.indexOf('central-pedidos') >= 0;
    this.initialDeliverySubType =
      isBalcaoRoute ? 'retirada' : 'entrega';

    this.routeContext = {
      urlRetorno: queryParams.urlRetorno || null,
      nome: queryParams.nome || null,
      tel: queryParams.tel || null,
      centralPedidos: isCentralRoute || (queryParams.central != null && this.parseBooleanishQueryParam(queryParams.central, true)),
      centralEmpresaOrigemId: queryParams.centralEmpresaOrigemId ? String(queryParams.centralEmpresaOrigemId) : null,
      centralContatoId: queryParams.centralContatoId ? String(queryParams.centralContatoId) : null,
      centralEnderecoId: queryParams.centralEnderecoId ? String(queryParams.centralEnderecoId) : null,
      bal: isBalcaoRoute,
      idMesa: queryParams.idm ? String(queryParams.idm) : null,
      idComanda: queryParams.idc ? String(queryParams.idc) : null,
      idCartaoConsumo: queryParams.idcc ? String(queryParams.idcc) : null,
      idGarcom: queryParams.idg ? String(queryParams.idg) : null,
      modoGarcom: queryParams.mg != null && this.parseBooleanishQueryParam(queryParams.mg, true),
      novaComanda: queryParams.novaComanda != null && this.parseBooleanishQueryParam(queryParams.novaComanda, true),
      codigoPedido: this.activatedRoute?.snapshot?.params?.codigo || null,
      copiar: routeConfigPath.indexOf('copiar') >= 0
    };
  }

  private resolveInitialOrderType(): string {
    if (this.routeContext.centralPedidos) return 'delivery';
    if (this.routeContext.idMesa) return 'mesa';
    if (this.routeContext.bal) return 'balcao';
    return 'delivery';
  }

  private applyInitialDeliverySubType() {
    if (this.orderType !== 'delivery' || this.subType === this.initialDeliverySubType) {
      return;
    }
    this.setSubType(this.initialDeliverySubType);
  }

  private applyRouteInitialContactPrefill() {
    if (this.routeContext.bal) {
      if (this.routeContext.nome) {
        this.identificacaoBalcao = this.routeContext.nome;
      }
      return;
    }
    if (this.routeContext.nome && !this.customerName) {
      this.customerName = this.routeContext.nome;
    }
    if (this.routeContext.tel && !this.customerPhone) {
      this.customerPhone = this.routeContext.tel;
    }
  }

  private bootstrapRouteContextData() {
    if (this.centralPedidosAtivo) {
      return;
    }

    if (this.routeBootstrapStarted && !this.routeContext.idMesa) {
      return;
    }
    this.routeBootstrapStarted = true;

    if (!this.routeContext.bal && !this.routeLookupContactDone && this.routeContext.tel) {
      this.routeLookupContactDone = true;
      this.contatosService.obtenhaContato(this.routeContext.tel).then((contato: any) => {
        if (contato?.id && !this.selectedContact) {
          this.selectClient(contato);
        }
      }).catch(() => {
        // Sem contato cadastrado: a v3 usa o telefone/nome de rota como fallback no payload.
      });
    }

    if (this.routeContext.idMesa && !this.routeLookupMesaDone) {
      this.routeLookupMesaDone = true;
      this.comandaService.obtenhaMesa(this.routeContext.idMesa).then((mesa: any) => {
        if (!mesa) return;
        this.mesaSelecionada = mesa;
        const numeroMesa = mesa.numero ?? mesa.nome ?? '';
        if (numeroMesa !== '' && numeroMesa !== null && numeroMesa !== undefined) {
          this.tableNum = String(numeroMesa);
        }
      }).catch(() => {});
    }

    if (this.routeContext.idComanda && !this.routeLookupComandaDone) {
      this.routeLookupComandaDone = true;
      this.comandaService.obtenhaComanda(this.routeContext.idComanda).then((comanda: any) => {
        this.comandaSelecionada = comanda || null;
      }).catch(() => {});
    }

    if (this.routeContext.idCartaoConsumo && !this.routeLookupCartaoDone) {
      this.routeLookupCartaoDone = true;
      this.cartaoClienteService.obtenhaCartao(Number(this.routeContext.idCartaoConsumo)).then((cartao: any) => {
        this.cartaoClienteSelecionado = cartao || null;
        if (cartao?.empresa) {
          this.empresa = cartao.empresa;
        }
      }).catch(() => {});
    }

    if ((this.routeContext.modoGarcom || this.routeContext.idGarcom) && !this.routeLookupGarcomDone) {
      this.routeLookupGarcomDone = true;

      if (this.routeContext.modoGarcom) {
        const operador = this.autorizacaoService.getUser();
        if (operador) {
          this.garcomSelecionado = {id: operador.id, nome: operador.nome, codigoPdv: operador.codigoPdv};
        }
      } else if (this.routeContext.idGarcom) {
        this.usuarioService.obtenhaGarcom(this.routeContext.idGarcom).then((garcom: any) => {
          this.garcomSelecionado = garcom || null;
        }).catch(() => {});
      }
    }

    this.applyMesaNoIdentificationFallbackIfNeeded();
  }

  private applyMesaNoIdentificationFallbackIfNeeded() {
    if (this.orderType !== 'mesa') return;
    if (!this.empresa) return;
    if (this.routeMesaNoIdApplied) return;
    if (this.selectedContact) return;
    if (this.routeContext.tel) return;

    const permitirNaoIdentificado = !!this.empresa?.pedidoMesaNaoIdentificado;
    if (!permitirNaoIdentificado) return;

    this.routeMesaNoIdApplied = true;
    const contato = this.buildFallbackMesaContact();
    this.customerName = contato.nome;
    this.customerPhone = contato.codigoPais + contato.telefone;
  }

  private parseBooleanishQueryParam(value: any, defaultValue: boolean): boolean {
    if (value === '' || value === true) return true;
    if (typeof value === 'boolean') return value;
    const normalized = String(value ?? '').trim().toLowerCase();
    if (!normalized) return true;
    if (['1', 'true', 't', 'yes', 'y', 'sim'].includes(normalized)) return true;
    if (['0', 'false', 'f', 'no', 'n', 'nao', 'não'].includes(normalized)) return false;
    return defaultValue;
  }

  private ensureDeliveryAddressRequirement(): boolean {
    if (!this.deliveryAddressRequired || this.hasDeliveryAddressSelected) {
      this.payAddressRequirementTouched = false;
      return true;
    }

    this.payAddressRequirementTouched = true;

    if (this.selectedContact?.id) {
      this.openSelectedClientAddressModal();
    } else {
      this.openClientModal();
    }

    return false;
  }

  private resetAll() {
    this.clearClientSearchTimer();
    this.clearCentralPedidosBuscaTimer();
    this.clearDeliveryFeeCalcTimer();
    this.clientSearchReqSeq++;
    this.centralPedidosBuscaReqSeq++;
    this.deliveryFeeReqSeq++;
    this.cart = [];
    this.selectedContact = null;
    this.selectedAddress = null;
    this.customerName = '';
    this.identificacaoBalcao = '';
    this.customerPhone = '';
    this.deliveryFeeLoading = false;
    this.deliveryFeeError = '';
    this.deliveryFeeLastCalcKey = '';
    this.deliveryFee = '';
    this.customerAddress = '';
    this.tableNum = '';
    this.selProduct = null;
    this.editingItem = null;
    this.qty = 1;
    this.selExtras = {};
    this.selSingleChoices = {};
    this.selCalda = null;
    this.colher = null;
    this.obs = '';
    this.discount = '';
    this.payMethods = [];
    this.payDiscount = '';
    this.payDiscountType = 'R$';
    this.payCupom = '';
    this.payTroco = '';
    this.payObs = '';
    this.marcarPedidoComoPago = false;
    this.agendarEntrega = false;
    this.dataAgendamento = null;
    this.horaAgendamento = null;
    this.payAgendamentoRequirementTouched = false;
    this.showPayGrid = true;
    this.availablePayMethods = [];
    this.payMethodSectionsView = [];
    this.legacyCashbackPayMethod = null;
    this.legacyResgatePayMethod = null;
    this.resetLoyaltyStates();
    this.productsLoading = false;
    this.search = '';
    this.activeCat = 'Todos';
    this.mCartOpen = false;
    this.mCustomizeOpen = false;
    this.sbVis = false;
    this.errors = {};
    this.fieldErrors = {};
    this.fieldShakeKey = {};
    this.printCupom = false;
    this.printVenda = false;
    this.salvando = false;

    if (this.centralPedidosAtivo) {
      this.centralPedidosDialogAberto = false;
      this.centralPedidosLojasDialogAberto = false;
      this.centralPedidosClienteSelecionado = null;
      this.centralPedidosEnderecos = [];
      this.centralPedidosEnderecoSelecionado = null;
      this.centralPedidosLojaManual = false;
      this.centralPedidosLojaDestino = null;
      this.centralPedidosRoteamento = null;
      this.centralPedidosEntrega = null;
      this.centralPedidosPreparando = false;
      this.centralAtendimentoPreparado = false;
      this.categorias = [];
      this.produtos = [];
      this._cachedCategoryList = [{nome: 'Todos', count: 0, cor: '#6366f1', fundo: '#eef2ff'}];
    }
  }

  // ==========================================
  // ATALHOS DE TECLADO
  // ==========================================
  @HostListener('window:keydown', ['$event'])
  handleKeyboard(event: KeyboardEvent) {
    // Modal aberto
    if (this.orderDone) {
      if (event.key === 'Enter' || event.key === 'F2' || event.key === 'Escape') {
        event.preventDefault();
        this.closeOrderDone();
        return;
      }
    }

    if (this.centralPedidosDialogAberto) {
      return;
    }

    if (this.centralPedidosLojasDialogAberto) {
      if (event.key === 'Escape') {
        event.preventDefault();
        this.fecheDialogLojasCentralPedidos();
      }
      return;
    }

    // F2
    if (event.key === 'F2') {
      event.preventDefault();
      if (this.payScreen) {
        this.handlePayCTA();
      } else if (!this.payScreen && this.cart.length > 0) {
        this.handleFinalizeOrderAction();
      }
      return;
    }

    // F3
    if (event.key === 'F3') {
      event.preventDefault();
      if (this.payScreen) {
        this.openAddPayMethod();
      }
      return;
    }

    // F4 — Selecionar cliente
    if (event.key === 'F4') {
      if (this.orderDone || this.showClientModal || this.selProduct || this.mCustomizeOpen) {
        return;
      }
      event.preventDefault();
      if (this.centralPedidosAtivo && this.selectedContact) {
        this.abraTrocaClientePedido();
        return;
      }
      this.openClientModal();
      return;
    }

    // Enter
    if (event.key === 'Enter') {
      const active = document.activeElement as HTMLElement | null;
      const activeTag = (active?.tagName || '').toUpperCase();
      const isTypingField = !!active && (
        activeTag === 'INPUT' ||
        activeTag === 'TEXTAREA' ||
        activeTag === 'SELECT' ||
        !!active.isContentEditable
      );

      if (this.payScreen) {
        if (activeTag === 'TEXTAREA') return;
        event.preventDefault();
        this.handlePayCTA();
        return;
      }

      if (this.selProduct && this.sbVis) {
        if (activeTag === 'TEXTAREA') return;
        event.preventDefault();
        this.confirmCustomize();
        return;
      }

      if (!isTypingField &&
          !this.showClientModal &&
          !this.orderDone &&
          !this.payScreen &&
          this.cart.length > 0) {
        event.preventDefault();
        this.handleFinalizeOrderAction();
        return;
      }
    }

    // Escape
    if (event.key === 'Escape') {
      if (this.showClientModal) {
        event.preventDefault();
        this.closeClientModal();
        return;
      }
      if (this.payScreen) {
        event.preventDefault();
        this.closePayScreen();
        return;
      }
      if (this.selProduct) {
        event.preventDefault();
        this.closeCustomize();
        return;
      }
    }
  }

  // ==========================================
  // HELPERS
  // ==========================================
  formatCurrency(value: number): string {
    if (value == null) return 'R$ 0,00';
    return 'R$ ' + value.toFixed(2).replace('.', ',');
  }

  getProductCode(p: any): string {
    return p.codigoPdv || p.codigo || ('#' + p.id);
  }

  getProductPrice(p: any): number {
    return p.preco || p.valor || 0;
  }

  resolveProductImage(p: any): string | null {
    if (this.failedImageIds.has(p?.id)) return null;
    const link = p?.imagens?.[0]?.linkImagem || p?.linkImagem || p?.imagem || null;
    if (!link) return null;
    if (/^https?:\/\//i.test(link)) return link;
    return '/images/empresa/' + String(link).replace(/^\/+/, '');
  }

  onProductImageError(p: any): void {
    if (p?.id != null) this.failedImageIds.add(p.id);
    p._image = null;
  }

  toggleProductPhotos(): void {
    this.showProductPhotos = !this.showProductPhotos;
    this.constantsService.pdvMostrarFotos = this.showProductPhotos;
    this.constantsService.togglePdvMostrarFotos();
  }

  trackById(index: number, item: any): any {
    return item.id;
  }

  trackByFieldKey(index: number, field: any): any {
    return field?.fieldKey || field?.id || index;
  }

  trackByOptionKey(index: number, option: any): any {
    return option?.optionKey || option?.id || option?.name || index;
  }

  trackByPaySection(index: number, section: PayMethodSectionVM): any {
    return section?.key || index;
  }

  trackByPayMethod(index: number, method: PayMethodVM): any {
    return method?.id || index;
  }

  trackBySelectedPayMethod(index: number, method: any): any {
    return `${String(method?.id ?? 'sem-id')}:${index}`;
  }
}
